// Reference to the global command queue for asynchronous execution of GPT-related calls.
var googletag = googletag || {};
googletag.cmd = googletag.cmd || [];

// Reference to the global command queue for asynchronous execution of Prebid-related calls.
var pbjs = pbjs || {};
pbjs.que = pbjs.que || [];

// =============================================================================
// 13092026-3 -- arm A: Equativ requested through the legacy Smart AdServer adapter
// =============================================================================
//
// Why: the 13.09.2026 A/B on this site proved that Equativ (network 4527) wins
// nothing through the "equativ" bidder code (newer OpenRTB adapter) and wins
// thousands of impressions per day through the legacy "smartadserver" code with
// the same siteId / pageId / formatId values. Arm A was the control of that test;
// the user decided (13.09 evening) that a working-vs-not-working control only
// costs money, so arm A gets the same rename. The RTB House no-floor test on arm B
// is unaffected and keeps its control here (this file keeps bidfloor: 0.10).
//
// What changes vs the live 05092026/ads-a: the 22 Equativ entries carry
// bidder: "smartadserver" instead of bidder: "equativ". Nothing else. Library for
// this arm becomes 13092026/prebid11.9.0.js (compiles BOTH Equativ adapters), so
// the way back to "equativ" is a wrapper-only rename once Equativ confirms the
// account on the OpenRTB endpoint. GAM reports Equativ as hb_bidder=smartadserver.
// =============================================================================


// =============================================================================
// TCF CMP WATCHDOG
// =============================================================================
//
// Background: a consentmanager.net CMP is embedded in this site's templates.
// When its remote configuration fails to load, the CMP answers every TCF query
// with cmpStatus "loading" forever: no banner is rendered, no consent string
// is ever produced, and gdprApplies stays true. GPT and Prebid are both
// consent-aware, so in that state neither of them sends a single ad request
// and every slot on the site goes dark. This happened for real on 03.09.2026
// and cost a full ad outage.
//
// What the failure actually looks like (measured 04.09.2026): the CMP core
// script loads and its first configuration call (/delivery/cmp.php) completes
// normally, but the answer carries no configuration -- the account's designs
// are all geo-targeted and none is marked as fallback, so a visitor whose
// country matches no design gets nothing. On a healthy load the design file
// (/delivery/customdata/...) is requested within a few milliseconds of
// cmp.php finishing; on the broken load nothing ever follows cmp.php.
//
// What this watchdog does:
//
//   1. It wraps window.__tcfapi in a transparent pass-through proxy. While
//      the CMP behaves normally, the proxy changes nothing: every call and
//      every event goes straight through, and consent behavior is entirely
//      the CMP's.
//
//   2. It watches the CMP's own network activity (the design-file <script>
//      element in the DOM, and the browser's resource timeline). If cmp.php
//      has completed and no design file has been requested for
//      CMP_NO_DESIGN_CONFIRM_MILLISECONDS afterwards, the
//      CMP is in the broken state described above and the watchdog takes
//      over. This is a positive detection of the failure, not a timeout, so
//      it fires early (about 2 seconds into the page) for a broken visitor and
//      NEVER fires for a visitor whose CMP is merely slow but progressing.
//
//   3. A visitor for whom the CMP IS progressing (design file requested, or
//      the CMP's own status advanced, or a real "cmpuishown" / "tcloaded"
//      event arrived) is left entirely to the real CMP. That includes EU
//      visitors, who must see the banner and whose ads must wait for their
//      choice. The watchdog stands down for good on any such signal.
//
//   4. As a last resort, if the CMP shows no progress at all for
//      CMP_WATCHDOG_MAX_WAIT_MILLISECONDS (its scripts never loaded, the
//      vendor is entirely unreachable), the watchdog also takes over, so a
//      genuine vendor outage still cannot black out the site for the
//      non-EEA audience.
//
//   5. Before taking over it checks the visitor's device timezone. A device
//      set to an unambiguously EEA/CH/UK timezone (Berlin, Vienna, Zurich,
//      Paris, ...) is never answered synthetically: for that visitor the
//      watchdog does nothing, and if the CMP cannot serve them they get no
//      ads rather than ads without consent. Timezones that Serbian devices
//      commonly report (the Windows "Belgrade, Bratislava, Budapest,
//      Ljubljana, Prague" group maps to Europe/Budapest on many machines)
//      are deliberately NOT on that list, so a Serbian visitor is never
//      denied ads by this check. It is a fail-safe, not a geo lookup.
//
//   6. On takeover, every TCF consumer that registered through the proxy
//      (GPT, Prebid) immediately receives a synthetic final answer with
//      gdprApplies = false, and every later TCF call is answered the same
//      way. gdprApplies = false is the correct resolution for this site's
//      overwhelmingly Serbian (non-EEA) audience and is exactly how the
//      working consentmanager instances on this network resolve for them.
//
//   7. It is self-healing in both directions. If the account is fixed, the
//      design file arrives on every load and the watchdog never fires. If the
//      real CMP asserts itself after a takeover (a genuine "cmpuishown" or
//      final event), the proxy returns to pass-through, the synthetic answers
//      stop, and the GPT recovery refresh is never issued.
//
// Known limitation, accepted: a consumer that registered its listener
// directly with the broken CMP BEFORE this wrapper executed cannot be
// notified through the proxy; the consentmanager registry rescue below
// covers that case for this vendor specifically.
//
// Debugging: window.__cmpWatchdog exposes
// { wrapped, takenOver, cmpFinal, cmpHealthy, takeoverReason, timezone, timezoneBlocked }.

// After the CMP's configuration call (cmp.php) has completed, how long to wait
// for the design file request before concluding the configuration was empty.
// On a healthy load the design file follows within ~10 ms; 750 ms is a very
// wide margin.
var CMP_NO_DESIGN_CONFIRM_MILLISECONDS = 750;

// Absolute ceiling: if the CMP has shown no progress of any kind for this
// long after the proxy was installed, take over anyway (vendor unreachable).
// Generous on purpose: an EU visitor on a slow connection may need several
// seconds just for cmp.php (measured 2.6 s from Germany), and taking over
// before that would bypass their banner. Serbian visitors on the broken
// instance are not affected by this value at all -- their takeover comes from
// the empty-configuration signature at ~2 s.
var CMP_WATCHDOG_MAX_WAIT_MILLISECONDS = 8000;

// How often the watchdog re-evaluates the CMP's progress.
var CMP_WATCHDOG_POLL_MILLISECONDS = 250;

// Device timezones that identify an EEA/CH/UK visitor beyond reasonable doubt.
// The synthetic "GDPR does not apply" answer is never given to these. The
// list intentionally omits every zone a Serbian device might report:
// Europe/Belgrade itself, and the Windows group-default zones Europe/Budapest
// (Belgrade/Bratislava/Budapest/Ljubljana/Prague group) and Europe/Warsaw
// (Sarajevo/Skopje/Warsaw/Zagreb group), plus Prague, Bratislava, Ljubljana
// and Zagreb which share those groups.
var CMP_WATCHDOG_EEA_DEVICE_TIMEZONES = [
    'Europe/Berlin', 'Europe/Vienna', 'Europe/Zurich', 'Europe/Amsterdam',
    'Europe/Brussels', 'Europe/Luxembourg', 'Europe/Paris', 'Europe/Madrid',
    'Europe/Rome', 'Europe/Malta', 'Europe/Copenhagen', 'Europe/Stockholm',
    'Europe/Oslo', 'Europe/Helsinki', 'Europe/Athens', 'Europe/Bucharest',
    'Europe/Sofia', 'Europe/Vilnius', 'Europe/Riga', 'Europe/Tallinn',
    'Europe/Dublin', 'Europe/London', 'Europe/Lisbon', 'Atlantic/Reykjavik',
    'Atlantic/Madeira', 'Atlantic/Azores', 'Atlantic/Canary', 'Europe/Nicosia',
    'Asia/Nicosia', 'Europe/Vaduz'
];

// The CMP stub is normally installed by the template before this file runs,
// but load order is not guaranteed. If window.__tcfapi is not there yet, the
// watchdog polls for it this often, for at most this long, then gives up
// (no CMP on the page means nothing blocks ad serving and there is nothing
// to guard).
var CMP_APPEARANCE_POLL_MILLISECONDS = 200;
var CMP_APPEARANCE_MAX_WAIT_MILLISECONDS = 10000;

(function installCmpWatchdog() {

    // Read-only state for debugging from the console / remote sessions.
    var watchdogState = {
        wrapped: false,
        takenOver: false,
        cmpFinal: false,
        cmpHealthy: false,
        takeoverReason: null,
        timezone: null,
        timezoneBlocked: false
    };
    window.__cmpWatchdog = watchdogState;

    // The CMP's own __tcfapi function once the proxy is installed.
    var realTcfApi = null;

    // Every listener registered through the proxy, so the watchdog can answer
    // them itself on takeover. Each entry is { callback, syntheticListenerId }.
    var proxiedListeners = [];

    // Synthetic listener ids start high so they can never collide with ids
    // handed out by the real CMP.
    var nextSyntheticListenerId = 100000;

    // The progress poll timer, and when the proxy was installed (poll clock).
    var progressPollTimer = null;
    var proxyInstalledAtMilliseconds = 0;

    function logWatchdog(message) {
        try {
            console.log('[ads.js CMP watchdog] ' + message);
        } catch (ignored) {}
    }

    function nowMilliseconds() {
        return new Date().getTime();
    }

    // True while the watchdog's synthetic answers are in force: it has taken
    // over AND the real CMP has neither finished nor asserted itself since.
    function syntheticAnswersActive() {
        return watchdogState.takenOver && !watchdogState.cmpFinal && !watchdogState.cmpHealthy;
    }

    // -------------------------------------------------------------------------
    // Device timezone fail-safe (see point 5 in the header comment).
    // -------------------------------------------------------------------------
    function readDeviceTimezone() {
        try {
            var intlObject = window.Intl || (typeof Intl !== 'undefined' ? Intl : null);
            if (!intlObject || typeof intlObject.DateTimeFormat !== 'function') {
                return null;
            }
            var resolved = intlObject.DateTimeFormat().resolvedOptions();
            if (resolved && typeof resolved.timeZone === 'string' && resolved.timeZone.length > 0) {
                return resolved.timeZone;
            }
        } catch (timezoneError) {
            return null;
        }
        return null;
    }

    function deviceLooksEea() {
        var timezone = readDeviceTimezone();
        watchdogState.timezone = timezone;
        if (timezone === null) {
            // Unknown timezone (very old browser): cannot tell, do not block.
            return false;
        }
        var zoneIndex;
        for (zoneIndex = 0; zoneIndex < CMP_WATCHDOG_EEA_DEVICE_TIMEZONES.length; zoneIndex++) {
            if (CMP_WATCHDOG_EEA_DEVICE_TIMEZONES[zoneIndex] === timezone) {
                return true;
            }
        }
        return false;
    }

    // -------------------------------------------------------------------------
    // CMP progress detection through the resource timeline and the CMP's own
    // public state (see points 2-4 in the header comment).
    // -------------------------------------------------------------------------

    // Returns { configCallCompletedAt: ms-since-page-start or null,
    //           designFileRequested: bool }.
    //
    // The design file is requested by the CMP core as an async <script>
    // element appended to the document the moment cmp.php has executed
    // (measured: 2 ms later). Its download can take several seconds on a slow
    // connection, and a resource-timeline entry only exists once a download
    // has COMPLETED -- so an in-flight design file is invisible in the
    // timeline. The DOM is therefore checked first: a <script> whose src is a
    // consentmanager /delivery/customdata/ URL means the configuration
    // arrived and a design is being fetched, i.e. the CMP is working for this
    // visitor, whether or not the file has finished downloading yet.
    function inspectCmpNetworkActivity() {
        var result = { configCallCompletedAt: null, designFileRequested: false };
        try {
            var scriptElements = document.getElementsByTagName('script');
            var scriptIndex;
            for (scriptIndex = 0; scriptIndex < scriptElements.length; scriptIndex++) {
                var scriptSource = String(scriptElements[scriptIndex].src || '');
                if (scriptSource.indexOf('consentmanager') !== -1 && scriptSource.indexOf('/delivery/customdata/') !== -1) {
                    result.designFileRequested = true;
                    break;
                }
            }
        } catch (domError) {
            // fall through to the timeline check
        }
        try {
            if (!window.performance || typeof window.performance.getEntriesByType !== 'function') {
                return result;
            }
            var resourceEntries = window.performance.getEntriesByType('resource');
            var entryIndex;
            for (entryIndex = 0; entryIndex < resourceEntries.length; entryIndex++) {
                var resourceName = String(resourceEntries[entryIndex].name);
                if (resourceName.indexOf('consentmanager') === -1) {
                    continue;
                }
                if (resourceName.indexOf('/delivery/cmp.php') !== -1) {
                    // responseEnd is exposed for cross-origin resources even
                    // without Timing-Allow-Origin; a still-in-flight request
                    // does not appear in the timeline at all.
                    var responseEnd = resourceEntries[entryIndex].responseEnd;
                    if (typeof responseEnd === 'number' && responseEnd > 0) {
                        if (result.configCallCompletedAt === null || responseEnd < result.configCallCompletedAt) {
                            result.configCallCompletedAt = responseEnd;
                        }
                    }
                }
                if (resourceName.indexOf('/delivery/customdata/') !== -1 || resourceName.indexOf('/delivery/info/') !== -1) {
                    result.designFileRequested = true;
                }
            }
        } catch (performanceError) {
            return result;
        }
        return result;
    }

    // The consentmanager core exposes window.cmpmngr.status: it stays at 1 in
    // the broken state and advances (4 = banner shown, 6 = finished) once the
    // configuration has arrived. Any advance beyond 1 is progress.
    function cmpVendorStatusAdvanced() {
        try {
            var cmpVendorObject = window.cmpmngr;
            if (cmpVendorObject && typeof cmpVendorObject.status === 'number' && cmpVendorObject.status > 1) {
                return true;
            }
        } catch (statusError) {
            return false;
        }
        return false;
    }

    // Milliseconds since the page's time origin, on the same clock as the
    // resource timeline entries.
    function millisecondsSincePageStart() {
        try {
            if (window.performance && typeof window.performance.now === 'function') {
                return window.performance.now();
            }
        } catch (performanceError) {
            return 0;
        }
        return 0;
    }

    // Marks the CMP as genuinely working for this visitor and stands the
    // watchdog down permanently. Called on any progress signal.
    function markCmpHealthy(reason) {
        if (watchdogState.cmpHealthy) {
            return;
        }
        watchdogState.cmpHealthy = true;
        stopProgressPoll();
        if (watchdogState.takenOver) {
            logWatchdog('real CMP asserted itself after a takeover (' + reason + '); synthetic answers withdrawn, proxy back to pass-through.');
        } else {
            logWatchdog('CMP is progressing on its own (' + reason + '); watchdog stood down.');
        }
    }

    function stopProgressPoll() {
        if (progressPollTimer !== null) {
            clearInterval(progressPollTimer);
            progressPollTimer = null;
        }
    }

    // One evaluation of the CMP's progress; runs every
    // CMP_WATCHDOG_POLL_MILLISECONDS until a decision is reached.
    function evaluateCmpProgress() {
        if (watchdogState.cmpFinal || watchdogState.cmpHealthy || watchdogState.takenOver) {
            stopProgressPoll();
            return;
        }

        if (cmpVendorStatusAdvanced()) {
            markCmpHealthy('cmpmngr.status advanced past 1');
            return;
        }

        var networkActivity = inspectCmpNetworkActivity();
        if (networkActivity.designFileRequested) {
            markCmpHealthy('design file requested');
            return;
        }

        var elapsedSinceInstall = nowMilliseconds() - proxyInstalledAtMilliseconds;

        if (networkActivity.configCallCompletedAt !== null) {
            var sinceConfigCall = millisecondsSincePageStart() - networkActivity.configCallCompletedAt;
            if (sinceConfigCall >= CMP_NO_DESIGN_CONFIRM_MILLISECONDS) {
                takeOver('cmp.php completed ' + Math.round(sinceConfigCall) + 'ms ago and no design file followed (empty configuration for this visitor)');
                return;
            }
        }

        if (elapsedSinceInstall >= CMP_WATCHDOG_MAX_WAIT_MILLISECONDS) {
            takeOver('no CMP progress of any kind within ' + CMP_WATCHDOG_MAX_WAIT_MILLISECONDS + 'ms (vendor unreachable)');
            return;
        }
    }

    // A minimal but complete TCData object representing "GDPR does not apply".
    // Consumers only read gdprApplies/eventStatus/cmpStatus in this case, but
    // the usual containers are present so nothing trips over a missing field.
    function buildSyntheticTcData() {
        return {
            // Marker so the watchdog's own observers can tell a synthetic
            // answer from a genuine CMP recovery; harmless extra field for
            // every other TCF consumer.
            syntheticWatchdogAnswer: true,
            tcString: '',
            tcfPolicyVersion: 4,
            cmpId: 31,
            cmpVersion: 1,
            gdprApplies: false,
            eventStatus: 'tcloaded',
            cmpStatus: 'loaded',
            isServiceSpecific: true,
            useNonStandardTexts: false,
            publisherCC: 'RS',
            purposeOneTreatment: false,
            listenerId: null,
            purpose: { consents: {}, legitimateInterests: {} },
            vendor: { consents: {}, legitimateInterests: {} },
            specialFeatureOptins: {},
            publisher: {
                consents: {},
                legitimateInterests: {},
                customPurpose: { consents: {}, legitimateInterests: {} },
                restrictions: {}
            }
        };
    }

    function answerListenerSynthetically(listenerEntry) {
        var syntheticData = buildSyntheticTcData();
        syntheticData.listenerId = listenerEntry.syntheticListenerId;
        try {
            listenerEntry.callback(syntheticData, true);
        } catch (listenerError) {
            logWatchdog('a TCF listener threw while receiving the synthetic answer: ' + listenerError);
        }
    }

    // After a takeover, the proxy can only answer consumers that registered
    // THROUGH it. A consumer that registered before this file executed (GPT's
    // pubads implementation wins that race on some page loads) left its
    // callback inside the real CMP's own registry, forever waiting -- the
    // proxy cannot reach it. For the consentmanager CMP specifically, that
    // registry is publicly reachable at window.cmpmngr.api.events as entries
    // of shape { type: 'tcfv2', listener: function, id: number }, so the
    // watchdog answers those held listeners directly as well. Every step is
    // guarded: any unexpected shape (different CMP vendor, changed internals
    // after a consentmanager update) simply skips the rescue and the proxy
    // path still covers consumers that registered normally. A consumer that
    // registered through the proxy also appears in this registry and will
    // receive the synthetic answer twice; TCF listeners are event streams and
    // both GPT and Prebid handle a repeated final event idempotently.
    // Registry entries already answered, keyed by the CMP's own listener id, so
    // retries never answer the same consumer twice.
    var rescuedRegistryIds = {};

    function rescueCmpHeldListeners() {
        var rescuedCount = 0;
        try {
            var cmpVendorObject = window.cmpmngr;
            if (!cmpVendorObject || !cmpVendorObject.api || !cmpVendorObject.api.events || typeof cmpVendorObject.api.events.forEach !== 'function') {
                return 0;
            }
            cmpVendorObject.api.events.forEach(function (registryEntry) {
                if (!registryEntry || registryEntry.type !== 'tcfv2' || typeof registryEntry.listener !== 'function') {
                    return;
                }
                if (rescuedRegistryIds[registryEntry.id] === true) {
                    return;
                }
                rescuedRegistryIds[registryEntry.id] = true;
                var syntheticData = buildSyntheticTcData();
                syntheticData.listenerId = registryEntry.id;
                try {
                    registryEntry.listener(syntheticData, true);
                    rescuedCount = rescuedCount + 1;
                } catch (listenerError) {
                    logWatchdog('a CMP-held TCF listener threw while receiving the synthetic answer: ' + listenerError);
                }
            });
        } catch (rescueError) {
            logWatchdog('CMP-held listener rescue skipped: ' + rescueError);
        }
        return rescuedCount;
    }

    // The registry (window.cmpmngr) belongs to the CMP's full code, which loads
    // over the network and can appear AFTER the takeover fired -- and consumers
    // held in the CMP's stub queue only land in the registry when that code
    // processes the queue. A single rescue pass at takeover therefore misses
    // late arrivals (verified live on 03.09.2026: same build freed GPT on one
    // site and missed it on the other purely by load timing). So the rescue
    // repeats every second for a while after takeover, answering each newly
    // appeared captive listener exactly once, and stops early if the CMP
    // genuinely recovers or asserts itself.
    var CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS = 1000;
    var CMP_RESCUE_MAX_DURATION_MILLISECONDS = 30000;


    // Ad requests that GPT attempted WHILE it was still consent-blocked are
    // dropped, not queued -- freeing GPT afterwards does not resend them
    // (verified live on 03.09.2026: one site's request timing landed after the
    // rescue and rendered, the other site's landed before it and stayed blank
    // with zero gampad requests). So after the first rescue pass that actually
    // freed listeners, wait a moment and check whether ANY ad request has left
    // the page; if none has, issue a single recovery refresh of all GPT slots.
    // The completed Prebid auctions' targeting is already set on the slots, so
    // the recovery request serves with full header-bidding competition.
    // Never issued once the real CMP has asserted itself: for that visitor
    // ad requests must wait for the real consent outcome.
    var gptRedispatchScheduled = false;

    function scheduleGptRedispatchIfSilent() {
        if (gptRedispatchScheduled) {
            return;
        }
        gptRedispatchScheduled = true;
        setTimeout(function () {
            try {
                if (!syntheticAnswersActive()) {
                    logWatchdog('real CMP is in charge; recovery refresh not issued.');
                    return;
                }
                var observedAdRequestCount = 0;
                try {
                    var resourceEntries = [];
                    if (window.performance && typeof window.performance.getEntriesByType === 'function') {
                        resourceEntries = window.performance.getEntriesByType('resource');
                    }
                    var entryIndex;
                    for (entryIndex = 0; entryIndex < resourceEntries.length; entryIndex++) {
                        if (String(resourceEntries[entryIndex].name).indexOf('gampad/ads') !== -1) {
                            observedAdRequestCount = observedAdRequestCount + 1;
                        }
                    }
                } catch (performanceError) {
                    observedAdRequestCount = 0;
                }
                if (observedAdRequestCount > 0) {
                    logWatchdog('GPT already dispatched ' + observedAdRequestCount + ' ad request(s); no recovery refresh needed.');
                    return;
                }
                if (window.googletag && window.googletag.cmd) {
                    window.googletag.cmd.push(function () {
                        window.googletag.pubads().refresh();
                    });
                    logWatchdog('GPT sent no ad requests while consent was blocked; issued a one-time recovery refresh of all slots.');
                }
            } catch (redispatchError) {
                logWatchdog('GPT recovery refresh skipped: ' + redispatchError);
            }
        }, 1500);
    }

    function startCmpRegistryRescueLoop() {
        var firstPassCount = rescueCmpHeldListeners() + rescueGppRegistryListeners();
        if (firstPassCount > 0) {
            logWatchdog('rescued ' + firstPassCount + ' listener(s) held inside the CMP registry (consumers that registered before this file executed).');
            scheduleGptRedispatchIfSilent();
        }
        var elapsedMilliseconds = 0;
        var rescueTimer = setInterval(function () {
            if (!syntheticAnswersActive()) {
                clearInterval(rescueTimer);
                return;
            }
            var passCount = rescueCmpHeldListeners() + rescueGppRegistryListeners();
            if (passCount > 0) {
                logWatchdog('rescued ' + passCount + ' more CMP-held listener(s) on a retry pass.');
                scheduleGptRedispatchIfSilent();
            }
            elapsedMilliseconds = elapsedMilliseconds + CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS;
            if (elapsedMilliseconds >= CMP_RESCUE_MAX_DURATION_MILLISECONDS) {
                clearInterval(rescueTimer);
            }
        }, CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS);
    }

    // Marks the CMP as finished and stands the watchdog down. Called whenever a
    // real final event is observed through the proxy.
    function markCmpFinal() {
        if (watchdogState.cmpFinal) {
            return;
        }
        watchdogState.cmpFinal = true;
        stopProgressPoll();
        logWatchdog('CMP reached a final state on its own; watchdog stood down.');
    }

    function takeOver(reason) {
        if (watchdogState.takenOver || watchdogState.cmpFinal || watchdogState.cmpHealthy) {
            return;
        }
        stopProgressPoll();

        // Fail-safe: never bypass consent for a device that is clearly in the
        // EEA. For that visitor the watchdog does nothing at all.
        if (deviceLooksEea()) {
            watchdogState.timezoneBlocked = true;
            logWatchdog('CMP looks broken (' + reason + ') but the device timezone is ' + watchdogState.timezone +
                ' (EEA); leaving consent to the real CMP, no synthetic answer for this visitor.');
            return;
        }

        watchdogState.takenOver = true;
        watchdogState.takeoverReason = reason;
        logWatchdog(
            'taking over: ' + reason + '; answering ' + proxiedListeners.length +
            ' registered TCF listener(s) with gdprApplies=false so ad serving can proceed.');
        var listenerIndex;
        for (listenerIndex = 0; listenerIndex < proxiedListeners.length; listenerIndex++) {
            answerListenerSynthetically(proxiedListeners[listenerIndex]);
        }
        takeOverGpp();
        startCmpRegistryRescueLoop();
    }

    // Watches a real CMP event. Final states per the TCF spec are "tcloaded"
    // (no UI needed) and "useractioncomplete" (user answered the banner).
    // "cmpuishown" is not final but proves the CMP is configured and working
    // for this visitor, so it counts as the CMP asserting itself.
    function observeRealEvent(tcData) {
        // A synthetic answer produced by this watchdog (delivered back to us
        // through the CMP registry rescue) must never count as the CMP
        // recovering -- only genuine CMP events may stand the watchdog down.
        if (tcData && tcData.syntheticWatchdogAnswer) {
            return;
        }
        if (!tcData) {
            return;
        }
        if (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete') {
            markCmpHealthy('real final event ' + tcData.eventStatus);
            markCmpFinal();
            return;
        }
        if (tcData.eventStatus === 'cmpuishown' || tcData.cmpStatus === 'loaded') {
            markCmpHealthy('real event ' + tcData.eventStatus + ' / cmpStatus ' + tcData.cmpStatus);
        }
    }



    // Consumers inside iframes -- and, on some pages, GPT itself -- talk to
    // the CMP through the TCF postMessage protocol aimed at the
    // __tcfapiLocator frame instead of calling window.__tcfapi directly.
    // Those requests never pass through the function proxy above, so after a
    // takeover the watchdog answers them here as well. Verified live on sd.rs
    // (03.09.2026): GPT bound itself to the postMessage path and stayed
    // blocked even after the function-path rescue -- __tcfapiCall messages
    // flowed with ZERO __tcfapiReturn replies from the broken CMP. While the
    // CMP is healthy (or before a takeover) this responder stays silent, and
    // it stands down permanently if the real CMP asserts itself.
    function installPostMessageResponder() {
        window.addEventListener('message', function (messageEvent) {
            if (!syntheticAnswersActive()) {
                return;
            }
            var payload = messageEvent && messageEvent.data;
            var usedJsonEncoding = false;
            if (typeof payload === 'string') {
                if (payload.indexOf('__tcfapiCall') === -1) {
                    return;
                }
                try {
                    payload = JSON.parse(payload);
                    usedJsonEncoding = true;
                } catch (parseError) {
                    return;
                }
            }
            if (!payload || !payload.__tcfapiCall || !messageEvent.source) {
                return;
            }
            var tcfCall = payload.__tcfapiCall;
            var returnValue;
            if (tcfCall.command === 'ping') {
                returnValue = {
                    gdprApplies: false,
                    cmpLoaded: true,
                    cmpStatus: 'loaded',
                    displayStatus: 'disabled',
                    apiVersion: '2.2',
                    cmpId: 31
                };
            } else {
                returnValue = buildSyntheticTcData();
            }
            var reply = { __tcfapiReturn: { returnValue: returnValue, success: true, callId: tcfCall.callId } };
            try {
                messageEvent.source.postMessage(usedJsonEncoding ? JSON.stringify(reply) : reply, '*');
            } catch (postError) {
                return;
            }
            // A consumer reached through this path may also have had its ad
            // requests dropped while blocked; make sure the one-time recovery
            // refresh check runs for this path too.
            if (tcfCall.command === 'addEventListener' || tcfCall.command === 'getTCData') {
                scheduleGptRedispatchIfSilent();
            }
        }, false);
    }

    // =========================================================================
    // GPP (GLOBAL PRIVACY PLATFORM) WATCHDOG
    // =========================================================================
    //
    // The same broken CMP that blocks TCF also implements a second, independent
    // consent signal API: GPP (Global Privacy Platform, used for US state
    // privacy laws and other non-EU frameworks). It fails identically:
    // window.__gpp answers every query with cmpStatus "loading" and
    // signalStatus "not ready" forever. Google Publisher Tag consults GPP in
    // addition to TCF before it will request ads, so even after the TCF
    // watchdog above frees GPT, a stuck GPP signal can still block ad serving
    // on its own. Confirmed live on sd.rs on 03.09.2026: TCF was fully
    // resolved (registry rescue answered every tcfv2 listener, prebid ran a
    // complete auction), yet zero ad requests ever fired until GPP was also
    // freed here.
    //
    // Mirrors the TCF watchdog's three surfaces -- the window.__gpp function,
    // the consentmanager registry (entries with type 'gpp'), and the
    // postMessage protocol via the __gppLocator frame -- and fires on the same
    // takeover as TCF. A healthy GPP resolves on its own and this code never
    // engages.

    var gppRealApi = null;
    var gppProxiedListeners = [];
    var gppNextSyntheticListenerId = 300000;
    var gppRescuedRegistryIds = {};

    // A resolved-and-nothing-applies GPP signal: no section of any privacy
    // framework currently applies, which is the correct declaration when the
    // audience is not covered by the regulations GPP encodes (this wrapper's
    // watchdog already declares the TCF/GDPR equivalent above for the same
    // non-EEA audience).
    function buildSyntheticGppPingData() {
        return {
            gppVersion: '1.1',
            cmpStatus: 'loaded',
            cmpDisplayStatus: 'hidden',
            signalStatus: 'ready',
            supportedAPIs: [],
            cmpId: 31,
            sectionList: [],
            applicableSections: [],
            gppString: '',
            parsedSections: {}
        };
    }

    // GPP's addEventListener callback receives an "event" object, not the ping
    // data directly. Different integrations read either event.data (spec says
    // a plain 'ready' string for the signalStatus event) or the ping-shaped
    // fields nested under event.pingData -- both are populated here, same
    // belt-and-braces approach as the TCF synthetic answer above.
    function buildSyntheticGppEvent(listenerId) {
        return {
            eventName: 'signalStatus',
            listenerId: listenerId,
            data: 'ready',
            pingData: buildSyntheticGppPingData()
        };
    }

    function answerGppListenerSynthetically(listenerEntry) {
        try {
            listenerEntry.callback(buildSyntheticGppEvent(listenerEntry.syntheticListenerId), true);
        } catch (listenerError) {
            logWatchdog('a GPP listener threw while receiving the synthetic answer: ' + listenerError);
        }
    }

    function takeOverGpp() {
        var listenerIndex;
        for (listenerIndex = 0; listenerIndex < gppProxiedListeners.length; listenerIndex++) {
            answerGppListenerSynthetically(gppProxiedListeners[listenerIndex]);
        }
        rescueGppRegistryListeners();
    }

    // Same shape as the TCF registry rescue, filtered to type 'gpp' entries;
    // deduped by registry id so a repeat retry pass never answers twice.
    function rescueGppRegistryListeners() {
        var rescuedCount = 0;
        try {
            var cmpVendorObject = window.cmpmngr;
            if (!cmpVendorObject || !cmpVendorObject.api || !cmpVendorObject.api.events || typeof cmpVendorObject.api.events.forEach !== 'function') {
                return 0;
            }
            cmpVendorObject.api.events.forEach(function (registryEntry) {
                if (!registryEntry || registryEntry.type !== 'gpp' || typeof registryEntry.listener !== 'function') {
                    return;
                }
                if (gppRescuedRegistryIds[registryEntry.id] === true) {
                    return;
                }
                gppRescuedRegistryIds[registryEntry.id] = true;
                try {
                    registryEntry.listener(buildSyntheticGppEvent(registryEntry.id), true);
                    rescuedCount = rescuedCount + 1;
                } catch (listenerError) {
                    logWatchdog('a CMP-held GPP listener threw while receiving the synthetic answer: ' + listenerError);
                }
            });
        } catch (rescueError) {
            logWatchdog('GPP registry rescue skipped: ' + rescueError);
        }
        return rescuedCount;
    }

    function installGppProxy() {
        if (typeof window.__gpp !== 'function') {
            return;
        }
        gppRealApi = window.__gpp;

        window.__gpp = function proxiedGpp(command, callback, parameter) {

            if (command === 'addEventListener' && typeof callback === 'function') {
                var listenerEntry = {
                    callback: callback,
                    syntheticListenerId: gppNextSyntheticListenerId
                };
                gppNextSyntheticListenerId = gppNextSyntheticListenerId + 1;
                gppProxiedListeners.push(listenerEntry);

                if (syntheticAnswersActive()) {
                    answerGppListenerSynthetically(listenerEntry);
                }

                gppRealApi(command, function (event, success) {
                    if (syntheticAnswersActive()) {
                        return;
                    }
                    callback(event, success);
                }, parameter);
                return;
            }

            if (command === 'removeEventListener') {
                var entryIndex;
                for (entryIndex = 0; entryIndex < gppProxiedListeners.length; entryIndex++) {
                    if (gppProxiedListeners[entryIndex].syntheticListenerId === parameter) {
                        gppProxiedListeners.splice(entryIndex, 1);
                        if (typeof callback === 'function') {
                            callback(true);
                        }
                        return;
                    }
                }
                gppRealApi(command, callback, parameter);
                return;
            }

            if (syntheticAnswersActive()) {
                if (typeof callback === 'function') {
                    callback(buildSyntheticGppPingData(), true);
                    return;
                }
                return;
            }

            gppRealApi(command, callback, parameter);
        };
    }

    // Consumers reaching GPP through postMessage (__gppCall / __gppReturn via
    // the __gppLocator frame), same reasoning as the TCF postMessage responder
    // above: some consumers, including GPT itself on some page loads, never
    // call window.__gpp directly.
    function installGppPostMessageResponder() {
        window.addEventListener('message', function (messageEvent) {
            if (!syntheticAnswersActive()) {
                return;
            }
            var payload = messageEvent && messageEvent.data;
            var usedJsonEncoding = false;
            if (typeof payload === 'string') {
                if (payload.indexOf('__gppCall') === -1) {
                    return;
                }
                try {
                    payload = JSON.parse(payload);
                    usedJsonEncoding = true;
                } catch (parseError) {
                    return;
                }
            }
            if (!payload || !payload.__gppCall || !messageEvent.source) {
                return;
            }
            var gppCallInfo = payload.__gppCall;
            var returnValue = gppCallInfo.command === 'addEventListener'
                ? buildSyntheticGppEvent(gppCallInfo.callId)
                : buildSyntheticGppPingData();
            var reply = { __gppReturn: { returnValue: returnValue, success: true, callId: gppCallInfo.callId } };
            try {
                messageEvent.source.postMessage(usedJsonEncoding ? JSON.stringify(reply) : reply, '*');
            } catch (postError) {
                return;
            }
            scheduleGptRedispatchIfSilent();
        }, false);
    }


    function installProxy() {
        realTcfApi = window.__tcfapi;
        watchdogState.wrapped = true;
        installPostMessageResponder();
        installGppProxy();
        installGppPostMessageResponder();

        window.__tcfapi = function proxiedTcfApi(command, version, callback, parameter) {

            // --- addEventListener -------------------------------------------
            // Record the consumer so the watchdog can answer it on takeover,
            // and ALWAYS forward the registration to the real CMP so that a
            // healthy (or later-asserting) CMP drives the consumer normally.
            if (command === 'addEventListener' && typeof callback === 'function') {
                var listenerEntry = {
                    callback: callback,
                    syntheticListenerId: nextSyntheticListenerId
                };
                nextSyntheticListenerId = nextSyntheticListenerId + 1;
                proxiedListeners.push(listenerEntry);

                if (syntheticAnswersActive()) {
                    // Late consumer after takeover: answer immediately so it
                    // never hangs, and still register with the real CMP below
                    // in case it asserts itself.
                    answerListenerSynthetically(listenerEntry);
                }

                realTcfApi(command, version, function (tcData, success) {
                    observeRealEvent(tcData);
                    // While synthetic answers are in force, suppress the CMP's
                    // eternal "loading" pings; only real progress is worth
                    // forwarding then (and observeRealEvent just lifted the
                    // suppression if this event was real progress).
                    if (syntheticAnswersActive()) {
                        return;
                    }
                    callback(tcData, success);
                }, parameter);
                return;
            }

            // --- removeEventListener ----------------------------------------
            // If the id is one of the watchdog's synthetic ids, confirm the
            // removal locally (the real CMP has never heard of that id).
            if (command === 'removeEventListener') {
                var entryIndex;
                for (entryIndex = 0; entryIndex < proxiedListeners.length; entryIndex++) {
                    if (proxiedListeners[entryIndex].syntheticListenerId === parameter) {
                        proxiedListeners.splice(entryIndex, 1);
                        if (typeof callback === 'function') {
                            callback(true);
                        }
                        return;
                    }
                }
                realTcfApi(command, version, callback, parameter);
                return;
            }

            // --- getTCData / ping / everything else -------------------------
            // While synthetic answers are in force, answer one-shot queries
            // synthetically (the real CMP would only ever say "loading"
            // again). Otherwise pure pass-through, with a peek at the answer
            // to spot progress or a final state.
            if (syntheticAnswersActive()) {
                if (command === 'ping' && typeof callback === 'function') {
                    callback({
                        gdprApplies: false,
                        cmpLoaded: true,
                        cmpStatus: 'loaded',
                        displayStatus: 'disabled',
                        apiVersion: '2.2',
                        cmpId: 31
                    }, true);
                    return;
                }
                if (typeof callback === 'function') {
                    callback(buildSyntheticTcData(), true);
                    return;
                }
                return;
            }

            realTcfApi(command, version, function (tcData, success) {
                observeRealEvent(tcData);
                if (typeof callback === 'function') {
                    callback(tcData, success);
                }
            }, parameter);
        };

        // The watchdog's own observer: register with the real CMP so progress
        // or a final state is noticed even if no other consumer ever registers.
        realTcfApi('addEventListener', 2, function (tcData, success) {
            if (success !== false) {
                observeRealEvent(tcData);
            }
        });

        proxyInstalledAtMilliseconds = nowMilliseconds();
        progressPollTimer = setInterval(evaluateCmpProgress, CMP_WATCHDOG_POLL_MILLISECONDS);
        logWatchdog('proxy installed; watching CMP progress (takeover ' + CMP_NO_DESIGN_CONFIRM_MILLISECONDS +
            'ms after an empty configuration answer, or after ' + CMP_WATCHDOG_MAX_WAIT_MILLISECONDS + 'ms without any progress).');
    }

    // The CMP stub normally exists before this file runs; if not, poll for a
    // while in case the template loads it late. No CMP at all means nothing
    // blocks ad serving, so the watchdog simply never engages.
    if (typeof window.__tcfapi === 'function') {
        installProxy();
    } else {
        var appearanceWaitedMilliseconds = 0;
        var appearancePollTimer = setInterval(function () {
            if (typeof window.__tcfapi === 'function') {
                clearInterval(appearancePollTimer);
                installProxy();
                return;
            }
            appearanceWaitedMilliseconds = appearanceWaitedMilliseconds + CMP_APPEARANCE_POLL_MILLISECONDS;
            if (appearanceWaitedMilliseconds >= CMP_APPEARANCE_MAX_WAIT_MILLISECONDS) {
                clearInterval(appearancePollTimer);
                logWatchdog('no __tcfapi appeared within ' + CMP_APPEARANCE_MAX_WAIT_MILLISECONDS + 'ms; nothing to guard.');
            }
        }, CMP_APPEARANCE_POLL_MILLISECONDS);
    }
})();

// -----------------------------------------------------------------------------
// Debug mode (opt-in)
// -----------------------------------------------------------------------------
//
// Enable with:
//   - URL: ?addebug=1
// This mode MUST NOT change ad behavior; it only logs and exposes read-only state.
//
// Keep this small and robust: never throw, never block, never mutate ad logic.
//
var ADS_DEBUG_ENABLED = (function () {
    try {
        var searchParams = new URLSearchParams(window.location.search);
        return String(searchParams.get("addebug")) === "1";
    } catch (error) {
        return false;
    }
})();

function adsDebugLog() {
    if (!ADS_DEBUG_ENABLED) {
        return;
    }
    try {
        // eslint-disable-next-line no-console
        console.log.apply(console, arguments);
    } catch (error) {
        // Intentionally ignore logging failures.
    }
}

// ID5 for secure signals sharing in GAM
window.ID5EspConfig = { 
    partnerId: 1355 // ID5 partnerId
};

// Amount of time (ms) that Prebid allows the bidders to respond to ad requests.
var PREBID_TIMEOUT = 1500;

// Per-adunit Prebid timeout overrides (ms)
var PREBID_TIMEOUT_BY_ADUNIT = {};

function getPrebidTimeoutForAdUnit(adUnitCode) {
    if (adUnitCode && PREBID_TIMEOUT_BY_ADUNIT && PREBID_TIMEOUT_BY_ADUNIT[adUnitCode]) {
        return PREBID_TIMEOUT_BY_ADUNIT[adUnitCode];
    }
    return PREBID_TIMEOUT;
}

// Refresh cadence for the currently rendered advertiser.
// Listed Direct advertisers use the longer interval in every slot (same
// behavior as Blic.rs, changed 28 Jul 2026 — previously Billboard only).
// Every other eligible impression uses the 20-second default interval.
var DEFAULT_REFRESH_INTERVAL_SECONDS = 20;
var DIRECT_ADVERTISER_REFRESH_INTERVAL_SECONDS = 30;
var GAM_DIRECT_ADVERTISER_IDS = [
    5081634183,
    5081526668
];

// Legacy/default interval used by older helper paths and debug output. Runtime
// scheduling uses getRefreshIntervalSeconds(divId).
var SECONDS_TO_WAIT_AFTER_VIEWABILITY = DEFAULT_REFRESH_INTERVAL_SECONDS;


// Cumulative viewability timer (pauses when not viewable).
// When enabled, the selected interval counts cumulatively, but requires the last continuous
// visible stretch to be at least 5s and currently >= VISIBILITY_PERCENT_FOR_REFRESH.
var USE_CUMULATIVE_VIEWABILITY_TIMER = true;
var MIN_CONTINUOUS_VIEWABILITY_SEGMENT_MS = 5000;
// Advertisers for which refresh shouldn't apply. Just add the company IDs e.g [3219368852, 3130234283].
var GAM_NOREFRESH_ADVERTISER_IDS = [];

// Campaigns for which refresh shouldn't apply. Just add the order IDs e.g [3219368852, 3130234283].
var GAM_NOREFRESH_ORDER_IDS = [];

// Ad units (div ids) for which refresh shouldn't apply. Just add the div IDs e.g ['Branding_Left', 'Branding_Right'].
var GAM_NOREFRESH_ADUNITS = ['Branding_Left', 'Branding_Right'];

// How far should the ad be for the lazy loading to activate.
var DISTANCE_IN_PIXELS_FOR_LAZY_LOADING = "500px";

// How much (in percent) should the ad slot be viewable. 
var VISIBILITY_PERCENT_FOR_REFRESH = 0.7;

// Variables for all defined slots. 
var Adhesion;
var Billboard;
var Billboard_2;
var Billboard_3;
var Billboard_4;
var Billboard_5;
var Branding_Left;
var Branding_Right;
var P1;
var P2;
var P3;
var P4;
var P5;
var P6;
var In_Text_1;
var In_Text_2;
var In_Text_3;
var In_Text_4;
var In_Text_5;
var In_Text_6;
var In_Text_7;
var In_Text_8;
var In_Text_9;
var In_Text_10;

// Top level ad unit path. 
var adUnitPath = "/161634325/Zena.rs/";

var adWindowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; //check user's screen width

// Ogury uses one shared mobile adUnitId across all Zena.rs positions.
var OGURY_MOBILE_ALL_ADUNIT_ID = "wm-hb-stdb-zena-ringi-87be1jqd3ecilt";

function getOguryAdUnitIdForDevice(desktopAdUnitId) {
    // Matches the wrapper size mapping: [0, 0] mobile, [469, 0] tablet.
    if (adWindowWidth < 469) {
        return OGURY_MOBILE_ALL_ADUNIT_ID;
    }
    return desktopAdUnitId;
}

// ATF and BTF array variables. 
var adUnitsATF = [];
var adUnitsBTF = [];

function runWrapper() {

    //console.log('Ad Wrapper: Script execution.');

    var adContainers = document.querySelectorAll('.wrapperAd'); // Find all divs which have wrapperAd class.

    googletag.cmd.push(function() { // Push the defined ad units to the GPT array.

        // Sticky GPT size mapping. 
        var sticky_mapping = googletag.sizeMapping()
        .addSize([1600, 0], [[728, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200], [1, 1]]) //desktop for bigger screens
        .addSize([1024, 0], [[728, 90], [750, 100], [1, 1]]) //desktop for smaller screens
        .addSize([469, 0], [[468, 60], [300, 50], [320, 50], [1, 1]]) //tablet
        .addSize([0, 0], [[300, 50], [320, 50], [300, 100], [320, 100], [1, 1]]) //mobile
        .build();

        // Billboard GPT size mapping.
        var billboard_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[728, 90], [970, 66], [950, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200], [980, 120], [930, 180], [970, 250], [980, 240], [980, 250], [990, 250], [1060, 250]]) //desktop
        .addSize([469, 0], [[468, 60], [300, 50], [320, 50]]) //tablet
        .addSize([0, 0], [[300, 50], [300, 75], [320, 80], [320, 50], [300, 100], [320, 100], [360, 50], [360, 100]]) //mobile
        .build();   
        
        // Billboard_# GPT size mapping.
        var billboard_infeed_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[728, 90], [970, 66], [950, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [750, 200], [580, 280], [980, 120], [930, 180], [970, 250], [980, 240], [980, 250], [990, 250], [1060, 250]]) //desktop
        .addSize([469, 0], [[468, 60], [300, 50], [320, 50]]) //tablet
        .addSize([0, 0], [[300, 50], [300, 75], [320, 80], [320, 50], [300, 100], [320, 100], [360, 50], [360, 100]]) //mobile
        .build();    

        // P GPT size mapping.
        var p_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]]) //desktop
        .addSize([469, 0], [[200, 200], [250, 250], [300, 250]]) //tablet
        .addSize([0, 0], [[200, 200], [250, 250], [300, 250], [336, 280]]) //mobile
        .build();

        // InText GPT size mapping.
        var inText_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[728, 90], [750, 100], [750, 200], [750, 250], [580, 280], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //desktop
        .addSize([469, 0], [[300, 50], [320, 50], [468, 60], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //tablet
        .addSize([0, 0], [[300, 50], [300, 75], [320, 80], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //mobile
        .build();

        // Branding (Left/Right) GPT size mapping (desktop-only).
        //
        // These are premium skin positions:
        // - Desktop only (no slot defined for tablet/mobile).
        // - Never lazy-loaded.
        // - Never refreshed (excluded via GAM_NOREFRESH_ADUNITS).
        //
        // Size provided by GAM:
        //   - 470x1080
        //
        var branding_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[470, 1080]]) //desktop only
        .addSize([0, 0], []) //no branding on tablet/mobile
        .build();


        adContainers.forEach(function(el) { // Runs through all of the wrapperAd divs.

            // **************** Sticky GPT and Prebid definition. *******************

            if (el.id === 'Adhesion') { // Check if Adhesion div is present in body. 

                // Sticky ad unit definition
                Adhesion = googletag.defineSlot(adUnitPath + 'Sticky', [[728, 90], [970, 90], [320, 50]], 'Adhesion')
                                    .defineSizeMapping(sticky_mapping)
                                    .setTargeting('position', 'Adhesion')
                                    .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                    .addService(googletag.pubads());
                
                // Push the defined Adhesion Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'Adhesion',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1600, 0], sizes: [[728, 90], [970, 90], [750, 100], [750, 200]] }, //desktop for bigger screens
                            { minViewPort: [1024, 0], sizes: [728, 90] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984534', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275345', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-foot-zena-ringi-t24yasls3z0v2g") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_1_970x90" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991973" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476543" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5215454" } },
                            { bidder: "richaudience", params: { pid: "oyEVxRv41q", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912382 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120620" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            // **************** Billboard GPT and Prebid definition. *******************

            else if (el.id === 'Billboard') { // Check if Billboard div is present in body. 

                // Billboard ad unit definition
                Billboard = googletag.defineSlot(adUnitPath + 'Billboard', [[970, 250]], 'Billboard')
                                     .defineSizeMapping(billboard_mapping)
                                     .setTargeting('position', 'Billboard')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined Billboard Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'Billboard',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984534', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275346', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-ey0lfyk9ppey8g") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_2_970x250" } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991974" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476544" } },
                            { bidder: "richaudience", params: { pid: "vg1gFU2yNO", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912384 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120621" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },]
                    }
                );

            }

            // **************** Billboard_2 GPT and Prebid definition. *******************

            else if (el.id === 'Billboard_2') { // Check if Billboard_2 div is present in body. 

                // Billboard_2 ad unit definition
                Billboard_2 = googletag.defineSlot(adUnitPath + 'Billboard_2', [[970, 250]], 'Billboard_2')
                                     .defineSizeMapping(billboard_infeed_mapping)
                                     .setTargeting('position', 'Billboard_2')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined Billboard_2 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_2',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984535', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275348', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-tg-thmb-zena-ringi-k61afyverj6f2v") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_3_970x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033459" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994830" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384515" } },
                            { bidder: "richaudience", params: { pid: "kVcQf5Nxcs", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035360 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125758" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            // **************** Billboard_3 GPT and Prebid definition. *******************

            else if (el.id === 'Billboard_3') { // Check if Billboard_3 div is present in body. 

                // Billboard_3 ad unit definition
                Billboard_3 = googletag.defineSlot(adUnitPath + 'Billboard_3', [[970, 250]], 'Billboard_3')
                                     .defineSizeMapping(billboard_infeed_mapping)
                                     .setTargeting('position', 'Billboard_3')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined Billboard_3 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_3',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984535', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275347', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-tg-thmb-zena-ringi-k61afyverj6f2v") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_4_970x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033460" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994831" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384516" } },
                            { bidder: "richaudience", params: { pid: "U7LyzSqxUn", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035362 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125759" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            // **************** Billboard_4 GPT and Prebid definition. *******************

            else if (el.id === 'Billboard_4') { // Check if Billboard_4 div is present in body. 

                // Billboard_4 ad unit definition
                Billboard_4 = googletag.defineSlot(adUnitPath + 'Billboard_4', [[970, 250]], 'Billboard_4')
                                     .defineSizeMapping(billboard_infeed_mapping)
                                     .setTargeting('position', 'Billboard_4')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined Billboard_4 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_4',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984535', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275349', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-tg-thmb-zena-ringi-k61afyverj6f2v") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_5_970x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033461" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994832" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384517" } },
                            { bidder: "richaudience", params: { pid: "qYQW0HpZCT", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035364 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125760" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            // **************** Billboard_5 GPT and Prebid definition. *******************

            else if (el.id === 'Billboard_5') { // Check if Billboard_5 div is present in body. 

                // Billboard_5 ad unit definition
                Billboard_5 = googletag.defineSlot(adUnitPath + 'Billboard_5', [[970, 250]], 'Billboard_5')
                                     .defineSizeMapping(billboard_infeed_mapping)
                                     .setTargeting('position', 'Billboard_5')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined Billboard_5 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_5',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[970, 90], [728, 90], [970, 250]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984535', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275350', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-tg-thmb-zena-ringi-k61afyverj6f2v") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_6_970x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033462" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994833" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384518" } },
                            { bidder: "richaudience", params: { pid: "0o4YNDox46", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035366 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125761" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            
            // **************** Branding_Left GPT and Prebid definition. *******************

            else if (el.id === 'Branding_Left') { // Check if Branding_Left div is present in body.

                // Desktop-only guard: do not define the slot on smaller viewports.
                if (adWindowWidth < 1024) {
                    return;
                }

                // Branding_Left ad unit definition
                Branding_Left = googletag.defineSlot(adUnitPath + 'Branding_Left', [[470, 1080]], 'Branding_Left')
                                        .defineSizeMapping(branding_mapping)
                                        .setTargeting('position', 'Branding_Left')
                                        .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                        .addService(googletag.pubads());

                // Push the defined Branding_Left Prebid placement to the ATF array.
                //
                // IMPORTANT:
                // Bidder parameters below are mirrored from the site's standard desktop stack.
                // Replace placement / site / unit / zone / format IDs with branding-specific values
                // if your demand sources require separate inventory mappings for this position.
                //
            }

            // **************** Branding_Right GPT and Prebid definition. *******************

            else if (el.id === 'Branding_Right') { // Check if Branding_Right div is present in body.

                // Desktop-only guard: do not define the slot on smaller viewports.
                if (adWindowWidth < 1024) {
                    return;
                }

                // Branding_Right ad unit definition
                Branding_Right = googletag.defineSlot(adUnitPath + 'Branding_Right', [[470, 1080]], 'Branding_Right')
                                         .defineSizeMapping(branding_mapping)
                                         .setTargeting('position', 'Branding_Right')
                                         .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                         .addService(googletag.pubads());

                // Push the defined Branding_Right Prebid placement to the ATF array.
                // See Branding_Left notes regarding bidder IDs.
            }

// **************** P1 GPT and Prebid definition. *******************

            else if (el.id === 'P1') { // Check if P1 div is present in body. 

                // P1 ad unit definition
                P1 = googletag.defineSlot(adUnitPath + 'P1', [[300, 250]], 'P1')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P1')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                              .addService(googletag.pubads());
                
                // Push the defined P1 Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'P1',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984536', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275351', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-jgiwyeft5krd1o") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_7_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991975" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476545" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5215456" } },
                            { bidder: "richaudience", params: { pid: "lBGbZPWXCn", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912386 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120624" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            // **************** P2 GPT and Prebid definition. *******************

            else if (el.id === 'P2') { // Check if P2 div is present in body. 

                // P2 ad unit definition
                P2 = googletag.defineSlot(adUnitPath + 'P2', [[300, 250]], 'P2')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P2')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                              .addService(googletag.pubads());
                
                // Push the defined P2 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P2',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984536', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275358', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-jgiwyeft5krd1o") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_8_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991976" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476546" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5215457" } },
                            { bidder: "richaudience", params: { pid: "OJdO4EWcAK", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912388 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120625" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }

            // **************** P3 GPT and Prebid definition. *******************

            else if (el.id === 'P3') { // Check if P3 div is present in body. 

                // P3 ad unit definition
                P3 = googletag.defineSlot(adUnitPath + 'P3', [[300, 250]], 'P3')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P3')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                              .addService(googletag.pubads());
                
                // Push the defined P3 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P3',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984536', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275357', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-jgiwyeft5krd1o") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_9_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991977" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476547" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5215458" } },
                            { bidder: "richaudience", params: { pid: "MctgD0vfro", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912390 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120626" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }   

            
            // **************** P4 GPT and Prebid definition. *******************

            else if (el.id === 'P4') { // Check if P4 div is present in body. 

                // P4 ad unit definition
                P4 = googletag.defineSlot(adUnitPath + 'P4', [[300, 250]], 'P4')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P4')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                              .addService(googletag.pubads());
                
                // Push the defined P4 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P4',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984536', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275356', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-jgiwyeft5krd1o") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_10_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033463" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994841" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384519" } },
                            { bidder: "richaudience", params: { pid: "p0Ntp09R6q", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035368 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "123584" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }   

            // **************** P5 GPT and Prebid definition. *******************

            else if (el.id === 'P5') { // Check if P5 div is present in body. 

                // P5 ad unit definition
                P5 = googletag.defineSlot(adUnitPath + 'P5', [[300, 250]], 'P5')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P5')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                              .addService(googletag.pubads());
                
                // Push the defined P5 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P5',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984536', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275355', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-jgiwyeft5krd1o") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_11_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033464" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994842" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384520" } },
                            { bidder: "richaudience", params: { pid: "bUJXke5UHk", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035370 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125177" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }   

            // **************** P6 GPT and Prebid definition. *******************

            else if (el.id === 'P6') { // Check if P6 div is present in body. 

                // P6 ad unit definition
                P6 = googletag.defineSlot(adUnitPath + 'P6', [[300, 250]], 'P6')
                              .defineSizeMapping(p_mapping)
                              .setTargeting('position', 'P6')
                              .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                              .addService(googletag.pubads());
                
                // Push the defined P6 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'P6',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[200, 200], [250, 250], [300, 250]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984536', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275354', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wd-hb-stdb-zena-ringi-jgiwyeft5krd1o") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_12_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033465" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994843" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384521" } },
                            { bidder: "richaudience", params: { pid: "LnZhqdRKkF", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035372 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125178" } },
                            { bidder: "teads", params: { pageId: 182476, placementId: 197481 } },
                        ]
                    }
                );

            }   

            // **************** In_Text_1 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_1') { // Check if In_Text_1 div is present in body. 

                // In_Text_1 ad unit definition
                In_Text_1 = googletag.defineSlot(adUnitPath + 'In_Text_1', [[300, 250]], 'In_Text_1')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_1')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_1 Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'In_Text_1',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275353', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_13_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991978" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476548" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5215459" } },
                            { bidder: "richaudience", params: { pid: "azi8RABPMM", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912392 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120627" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }   

            // **************** In_Text_2 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_2') { // Check if In_Text_2 div is present in body. 

                // In_Text_2 ad unit definition
                In_Text_2 = googletag.defineSlot(adUnitPath + 'In_Text_2', [[300, 250]], 'In_Text_2')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_2')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined InText_2 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_2',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275352', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_14_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991979" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476549" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5215460" } },
                            { bidder: "richaudience", params: { pid: "bQd1RgORcx", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912394 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120628" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }   

            // **************** In_Text_3 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_3') { // Check if In_Text_3 div is present in body. 

                // In_Text_3 ad unit definition
                In_Text_3 = googletag.defineSlot(adUnitPath + 'In_Text_3', [[300, 250]], 'In_Text_3')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_3')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_3 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_3',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275365', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_15_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "991980" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559476550" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5215461" } },
                            { bidder: "richaudience", params: { pid: "H0Vc4jkbuk", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 2912396 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "120629" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_4 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_4') { // Check if In_Text_4 div is present in body. 

                // In_Text_4 ad unit definition
                In_Text_4 = googletag.defineSlot(adUnitPath + 'In_Text_4', [[300, 250]], 'In_Text_4')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_4')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_4 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_4',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                            { bidder: 'adf', params: { mid: '2275364', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_16_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033466" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994848" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384522" } },
                            { bidder: "richaudience", params: { pid: "VuW0a2MBDN", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035374 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "124582" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_5 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_5') { // Check if In_Text_5 div is present in body. 

                // In_Text_5 ad unit definition
                In_Text_5 = googletag.defineSlot(adUnitPath + 'In_Text_5', [[300, 250]], 'In_Text_5')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_5')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_5 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_5',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275363', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_17_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033467" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "543994849" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384523" } },
                            { bidder: "richaudience", params: { pid: "Iwud03aPvs", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035376 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "124583" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_6 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_6') { // Check if In_Text_6 div is present in body. 

                // In_Text_6 ad unit definition
                In_Text_6 = googletag.defineSlot(adUnitPath + 'In_Text_6', [[300, 250]], 'In_Text_6')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_6')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_6 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_6',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275362', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_18_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033468" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559748196" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384524" } },
                            { bidder: "richaudience", params: { pid: "7xuQMWsEpc", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035378 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125172" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_7 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_7') { // Check if In_Text_7 div is present in body. 

                // In_Text_7 ad unit definition
                In_Text_7 = googletag.defineSlot(adUnitPath + 'In_Text_7', [[300, 250]], 'In_Text_7')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_7')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_7 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_7',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275361', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_19_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033469" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559748197" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384525" } },
                            { bidder: "richaudience", params: { pid: "lzCojWESyN", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035380 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125173" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_8 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_8') { // Check if In_Text_8 div is present in body. 

                // In_Text_8 ad unit definition
                In_Text_8 = googletag.defineSlot(adUnitPath + 'In_Text_8', [[300, 250]], 'In_Text_8')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_8')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_8 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_8',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275360', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_20_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033470" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559748198" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384526" } },
                            { bidder: "richaudience", params: { pid: "Nqgrg220pk", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035382 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125174" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_9 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_9') { // Check if In_Text_9 div is present in body. 

                // In_Text_9 ad unit definition
                In_Text_9 = googletag.defineSlot(adUnitPath + 'In_Text_9', [[300, 250]], 'In_Text_9')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_9')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_9 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_9',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275359', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_21_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033471" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559748199" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384527" } },
                            { bidder: "richaudience", params: { pid: "Pzep8tfX9w", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035384 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125175" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

            // **************** In_Text_10 GPT and Prebid definition. *******************

            else if (el.id === 'In_Text_10') { // Check if In_Text_10 div is present in body. 

                // In_Text_10 ad unit definition
                In_Text_10 = googletag.defineSlot(adUnitPath + 'In_Text_10', [[300, 250]], 'In_Text_10')
                                     .defineSizeMapping(inText_mapping)
                                     .setTargeting('position', 'In_Text_10')
                                     .setTargeting('refresh_count', '0')
                                    .setTargeting('refresh_bucket', getRefreshBucket(0))
                                     .addService(googletag.pubads());
                
                // Push the defined In_Text_10 Prebid placement IDs to the BTF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_10',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[728, 90], [200, 200], [250, 250], [300, 250], [336, 280], [750, 100], [750, 200]] }, //desktop
                            { minViewPort: [469, 0], sizes: [[468, 60], [200, 200], [250, 250], [300, 250], [336, 280], [300, 50], [320, 50]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100], [200, 200], [250, 250], [300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                                                    { bidder: 'mediapool', params: { mid: '1984538', priceType: 'net' } },
                                                    { bidder: 'adf', params: { mid: '2275366', priceType: 'net' } },
                            { bidder: "ogury", params: { assetKey: "OGY-C1F15ED26FA7", adUnitId: getOguryAdUnitIdForDevice("wm-hb-iart-zena-ringi-u3lrgxd2ejwhq0") } },
                            { bidder: "taboola", params: { publisherId: "2048738", tagId: "100008371_22_300x250" } },
                            //{ bidder: "connectad", params: { networkId: 44, siteId: 1055176 } },
                            { bidder: "eskimi", params: { placementId: 1574 } },
                            { bidder: "ix", params: { siteId: "1033472" } },
                            { bidder: "openx", params: { delDomain: "ringieraxelspr-d.openx.net", unit: "559748200" } },
                            //{ bidder: "pubmatic", params: { publisherId: "158892", adSlot: "5384528" } },
                            { bidder: "richaudience", params: { pid: "lIU3RBXxTT", supplyType: "site" } },
                            { bidder: "rtbhouse", params: { region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10 } },
                            { bidder: "rubicon", params: { accountId: 19712, siteId: 490738, zoneId: 3035386 } },
                            { bidder: "smartadserver", params: { networkId: "4527", siteId: "600015", pageId: "1833843", formatId: "125176" } },
                            { bidder: "teads", params: { pageId: 182477, placementId: 197482 } },
                        ]
                    }
                );

            }  

        }); // End of wrapperAd divs check. 

        //Create sticky ad once the ad is ready to render
        googletag.pubads().addEventListener('slotRenderEnded', function(event) {

            // Passive render-result telemetry for future adaptive-refresh analysis.
            try {
                var renderedDivId = event.slot && event.slot.getSlotElementId && event.slot.getSlotElementId();
                if (renderedDivId) {
                    var renderedState = getOrCreateRefreshState(renderedDivId);
                    var renderTimestamp = Date.now();
                    var recentPrebidWin = auctionQualityRecentPrebidWinsByAdUnit[renderedDivId] || null;
                    var renderedSource = Boolean(event.isEmpty)
                        ? "unfilled"
                        : (recentPrebidWin && (renderTimestamp - recentPrebidWin.timestamp) <= 10000 ? "prebid" : "gam");

                    renderedState.lastRenderResult = {
                        timestamp: renderTimestamp,
                        isEmpty: Boolean(event.isEmpty),
                        source: renderedSource,
                        prebidWin: renderedSource === "prebid" ? recentPrebidWin : null,
                        advertiserId: event.advertiserId || null,
                        campaignId: event.campaignId || null,
                        lineItemId: event.lineItemId || null,
                        creativeId: event.creativeId || null,
                        sourceAgnosticCreativeId: event.sourceAgnosticCreativeId || null,
                        sourceAgnosticLineItemId: event.sourceAgnosticLineItemId || null,
                        yieldGroupIds: event.yieldGroupIds || null
                    };

                    try {
                        // Start a fresh cadence window for the newly rendered creative.
                        // Any slot rendering a listed Direct advertiser switches to 30
                        // seconds; every other refreshable slot uses 20 seconds.
                        renderedState.cumulativeViewableMs = 0;
                        renderedState.lastAboveThresholdTimestamp = renderedState.isAboveVisibilityThreshold
                            ? renderTimestamp
                            : null;

                        if (
                            renderedState.isAboveVisibilityThreshold &&
                            document.visibilityState === "visible" &&
                            !GAM_NOREFRESH_ADUNITS.includes(renderedDivId)
                        ) {
                            adsDebugLog(
                                "[ads-refresh]",
                                renderedDivId,
                                "render cadence selected",
                                {
                                    advertiserId: renderedState.lastRenderResult.advertiserId,
                                    intervalSeconds: getRefreshIntervalSeconds(renderedDivId)
                                }
                            );
                            scheduleRefreshWindowFromNow(renderedDivId);
                        }
                    } catch (cadenceError) {
                        adsDebugLog(
                            "[ads-refresh]",
                            renderedDivId,
                            "render cadence update failed",
                            String(cadenceError)
                        );
                    }
                }
            } catch (telemetryError) {
                adsDebugLog("[auction-quality] render_capture_failed", String(telemetryError));
            }

            let unitPath = event.slot.getAdUnitPath(); //get the ad unith path for the slot which will render the ad
            let stickyBackground = document.getElementById('adhesion_background'); //get the adhesion background id
            //let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; //check user's screen width

            if (unitPath === adUnitPath + "Sticky" && event.isEmpty === true) {
                let sticky = document.getElementById('Adhesion');
                sticky.style.display = 'none';
            }

            // if ad unit is sticky and the background is not set, set sticky CSS for sticky ad unit
            else if (unitPath === adUnitPath + "Sticky" && stickyBackground === null){
            let sticky = document.getElementById('Adhesion');
            sticky.style.position = 'fixed';
            sticky.style.zIndex = '999999';
            sticky.style.width = '100%';
            sticky.style.height = '';
            sticky.style.bottom = '0px';
            sticky.style.textAlign = 'center';	
            sticky.style.padding = '10px 0px 0px';
            sticky.style.borderTop = '1px #CCC solid';
            
            // create adhesion background
            let background = document.createElement("div");
            background.setAttribute("ID", "adhesion_background");
            background.style.backgroundColor = '#FFF';
            
            if (adWindowWidth > 1024) {
                background.style.opacity = '70%';
            }

            else {
                background.style.opacity = '100%';
            }

            background.style.position = 'absolute';
            background.style.height = '100%';
            background.style.width = '100%';
            background.style.top = '0';
            background.style.left = '0';
            background.style.zIndex = '-1';
            sticky.appendChild(background);

            // create placeholder text
            /*let placeholder = document.createElement("div");
            placeholder.setAttribute("ID", "adText");
            placeholder.style.textAlign = 'center';
            placeholder.style.fontSize = '10px';
            placeholder.style.color = '#CCC';
            placeholder.style.height = '20px';
            placeholder.style.borderTop = '1px #CCC solid';
            placeholder.style.paddingTop = '2px';
            placeholder.textContent = 'Oglas'
            background.appendChild(placeholder);*/
        
            // create close button with svg elements
            let closeButton = document.createElement("div");
            closeButton.setAttribute("ID", "close_adhesion")
            closeButton.style.position = 'absolute';
            closeButton.style.top = '-29px';
            closeButton.style.right = '0px';
            closeButton.style.cursor = 'pointer';
            closeButton.style.padding = '8px';
            //closeButton.style.borderRadius = '50%';
            closeButton.style.border = '1px solid #CCC';
            //closeButton.style.boxShadow = '0 0 3px #b8b9be';
            closeButton.style.background = '#FFF';
            closeButton.style.borderBottom = '1px solid #FFF';
            closeButton.style.borderTopLeftRadius = '10px';
            
            let iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            let iconPath = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'path'
            );

            iconSvg.setAttribute('display', 'block');
            iconSvg.setAttribute('fill', '#000');
            iconSvg.setAttribute('width', '12px');
            iconSvg.setAttribute('height', '12px');
            iconSvg.setAttribute('viewBox', '0 0 8 8');

            iconPath.setAttribute(
                'd',
                'M1.41 0l-1.41 1.41.72.72 1.78 1.81-1.78 1.78-.72.69 1.41 1.44.72-.72 1.81-1.81 1.78 1.81.69.72 1.44-1.44-.72-.69-1.81-1.78 1.81-1.81.72-.72-1.44-1.41-.69.72-1.78 1.78-1.81-1.78-.72-.72z'
            );
            
            iconSvg.appendChild(iconPath);
            closeButton.appendChild(iconSvg); 
            sticky.appendChild(closeButton);
            
            // when user clicks the close button, remove the sticky div
            document.getElementById("close_adhesion").addEventListener('click', function(e) {
                e.preventDefault();
                sticky.parentNode.removeChild(sticky);
            }, false); 


            } 
        });
        
        // Check if adsKeywords object is present
        if (typeof adsKeywords != 'undefined') {

            // Check if adsKeywords attributes are present, if so, pass them as key values to GAM
            if (typeof adsKeywords.category != 'undefined') {
                googletag.pubads().setTargeting('category', adsKeywords.category);
            } 

            if (typeof adsKeywords.subcategory != 'undefined') {
                googletag.pubads().setTargeting('subcategory', adsKeywords.subcategory);
            } 

            if (typeof adsKeywords.pageType != 'undefined') {
                googletag.pubads().setTargeting('pageType', adsKeywords.pageType);
            } 

            if (typeof adsKeywords.articleUuid != 'undefined') {
                googletag.pubads().setTargeting('articleId', [adsKeywords.articleUuid].join(','));
            } 
            
            if (typeof adsKeywords.articleTags != 'undefined') {
                googletag.pubads().setTargeting('articleTags', [adsKeywords.articleTags].join(','));
            } 
        }

        let adQueryString = window.location.search; // Get the whole string in the URL. 
        //console.log("Query string is " + adQueryString);

        let adUrlParams = new URLSearchParams(adQueryString); // Get the information after ? in the URL. 
        //console.log("URL param is " +  adUrlParams);

        if (adUrlParams.has('adTest')) { 
            let adValue = adUrlParams.get('adTest'); // If there is a adTest param get the value after =. 
            //console.log("AdTest value is " + adValue);
            googletag.pubads().setTargeting('adTest', adValue); // Send the adTest value to GAM.
        } 

        if (adUrlParams.has('utm_source')) {
            let utmSource = adUrlParams.get('utm_source'); // If there is a utm_source param get the value after =. 
            //console.log("UTM source value is " + utmSource);
            googletag.pubads().setTargeting('utmSource', utmSource); // Send the utm_source value to GAM.
        } 

        if (adUrlParams.has('utm_medium')) {
            let utmMedium = adUrlParams.get('utm_medium'); // If there is a utm_medium param get the value after =. 
            //console.log("UTM medium value is " + utmMedium);
            googletag.pubads().setTargeting('utmMedium', utmMedium); // Send the utm_medium value to GAM.
        } 

        let refURL = document.referrer; // Get the URL from which the user came. 

        if (refURL.length === 0) {
            googletag.pubads().setTargeting('referrer', 'direct');
        } 

        else if (refURL.includes("google")) {
            googletag.pubads().setTargeting('referrer', 'google');
        } 
          
        else if (refURL.includes("linkedin") || refURL.includes("t.com") || refURL.includes("facebook") || refURL.includes("instagram")) {
            googletag.pubads().setTargeting('referrer', 'social');
        } 
          
        else if (refURL.includes("blic.rs") || refURL.includes("pulsonline.rs") || refURL.includes("ana.rs") || refURL.includes("nekretnine.rs") || refURL.includes("mojauto.rs")) {
            googletag.pubads().setTargeting('referrer', 'ringier');
        } 
          
        else {
            googletag.pubads().setTargeting('referrer', 'other');
        }

        

        // CX targeting
        if(typeof window.localStorage === 'object' && typeof window.localStorage.getItem === 'function' && localStorage.getItem("CxSegments") !== null && localStorage.getItem("CxSegments").length>0) {
            googletag.pubads().setTargeting('CxSegments', localStorage.getItem('CxSegments').split(','));
        }

        if(typeof window.localStorage === 'object' && typeof window.localStorage.getItem === 'function' && localStorage.getItem("CxCmbnd") !== null && localStorage.getItem("CxCmbnd").length>0) {
            googletag.pubads().setTargeting('CxCmbnd', localStorage.getItem('CxCmbnd').split(','))
        }

        googletag.pubads().disableInitialLoad(); // Disables requests for ads on page load. 
        googletag.pubads().enableSingleRequest(); // Enables single request mode for fetching multiple ads at the same time.
        googletag.pubads().setCentering(true);
        googletag.enableServices(); // Enables all GPT services that have been defined for ad slots on the page.

        // Get the list of slots associated with this service.
        googletag.pubads().getSlots().forEach(function(adSlots) {
            googletag.display(adSlots.getSlotElementId()); // Instructs slot services to render all of the defined ad slots. 
        });

    });

    pbjs.que.push(function() {

        pbjs.aliasBidder('adf', 'mediapool', {gvlid:50});
    
        pbjs.setConfig({
    
            priceGranularity: 'high', //$0.01 increments, up to $20

            enableSendAllBids: false, //send only top bids
            targetingControls: {
              alwaysIncludeDeals: true //send all deal bids
            },
    
            //Currency module
            currency: {
                "adServerCurrency": "EUR",
                "conversionRateFile": "https://cdn.jsdelivr.net/gh/prebid/currency-file@1/latest.json",
             },
    
            //Coockie match and user syncs
            userSync: {
                syncEnabled: true,
                syncsPerBidder: 5,
                syncDelay: 3000,
                auctionDelay: 50,
                userIds: [
    
                    { name: "sharedId", 
                      storage: { type: "cookie", name: "_sharedid", expires: 365 } 
                    },
    
                    { name: "id5Id",
                        params: { partner: 1355, externalModuleUrl: 'https://cdn.id5-sync.com/api/1.0/id5PrebidModule.js' },
                        storage: { type: "html5", name: "id5id", expires: 90, refreshInSeconds: 8*3600 }
                    },
    
                    { name: 'teadsId',
                      params: { pubId: 26849 }
                    },
    
                    { name: 'lotamePanoramaId',
                    },
    
                ],
                aliasSyncEnabled: true,
                filterSettings: { all: { bidders: "*", filter: "include" } },
            },

            enableTIDs: true,

            // defaultGdprScope is deliberately false: if the CMP never answers
            // (and even the TCF watchdog at the top of this file somehow fails
            // to take over), Prebid proceeds after the timeout treating GDPR as
            // not applying, which is the correct resolution for this site's
            // non-EEA (Serbian) audience. With defaultGdprScope true, a stuck
            // CMP means "GDPR applies with zero consent" and every auction
            // dies — that is exactly the failure mode that took the site's ads
            // down on 03.09.2026.
            consentManagement: {
                gdpr: {
                  cmpApi: 'iab',
                  timeout: 8000,
                  defaultGdprScope: false
                }
            },

            /*paapi: {
                enabled: true,
                gpt: {
                    autoconfig: false
                },
                defaultForSlots: 1
            },*/
            
            //useBidCache: true,

        });

        pbjs.bidderSettings = {
            standard: {
                storageAllowed: true,
            },

            // Taboola requires localStorage access for its own bidder. The standard
            // block above already grants it to every bidder, so this entry is
            // redundant today, but Taboola asks for it per-bidder and declaring it
            // explicitly keeps the requirement visible if the standard default is
            // ever tightened.
            //
            // The key must be lowercase 'taboola' so that it matches the bidder code
            // used in the ad units. Taboola's own documentation writes it as
            // bidderSettings["Taboola"], which would silently never apply, because
            // Prebid matches these keys against the bidder code exactly.
            taboola: {
                storageAllowed: true,

                // Convert Taboola's bids from gross to net with a 0.75 multiplier.
                //
                // Taboola states this is required whenever every other SSP in the
                // setup already bids net, and that is the case here: adf and its
                // mediapool alias declare priceType 'net' explicitly on every
                // placement, and the rest of the Zena stack was confirmed to bid net
                // on 24.08.2026 -- the same finding that prompted the identical
                // change on Blic.rs on the same day.
                //
                // Without this multiplier Taboola's gross bids sit roughly 33% high
                // against every other bidder, so Taboola wins auctions it should lose
                // and displaces demand that is genuinely worth more. A bidder winning
                // on an inflated bid looks like strong performance in reporting while
                // actually costing money, which is what makes this easy to miss:
                // Taboola's measured 12.0% share of top bids on Zena (22 days to
                // 18.08.2026) was produced WITHOUT this adjustment and is therefore
                // overstated. Expect its win share to fall after this change; that is
                // the correction working, not a regression.
                //
                // If the stack ever moves to gross bidding, this multiplier must be
                // removed at the same time, or Taboola will be penalised by 25%.
                bidCpmAdjustment: function (bidCpm) {
                    return bidCpm * 0.75;
                },
            },
        }; 
        
    
        //Add only ATF ad units.
        pbjs.addAdUnits(adUnitsATF);
        
        //Request bids.
        // Request bids (Billboard uses a shorter timeout).
        var atfAdUnitCodes = adUnitsATF.map(function (adUnit) { return adUnit.code; });

        var atfBillboardCodes = atfAdUnitCodes.filter(function (code) { return code === 'Billboard'; });
        var atfNonBillboardCodes = atfAdUnitCodes.filter(function (code) { return code !== 'Billboard'; });

        if (atfBillboardCodes.length > 0) {
            pbjs.requestBids({
                adUnitCodes: atfBillboardCodes,
                bidsBackHandler: initBillboardAdserver,
                timeout: getPrebidTimeoutForAdUnit('Billboard')
            });
        }

        if (atfNonBillboardCodes.length > 0) {
            pbjs.requestBids({
                adUnitCodes: atfNonBillboardCodes,
                bidsBackHandler: function () { initNonBillboardAdserver(atfNonBillboardCodes); },
                timeout: PREBID_TIMEOUT
            });
        }

        if (atfBillboardCodes.length === 0 && atfNonBillboardCodes.length === 0) {
            initNonBillboardAdserver([]);
        }
});

    // Send requests to the SSPs and send bids to GAM for the Billboard slot first.
    function initBillboardAdserver() {
        if (pbjs.billboardInitAdserverSet) return;
        pbjs.billboardInitAdserverSet = true;

        googletag.cmd.push(function () {
            pbjs.que.push(function () {
                // Do NOT wait for user IDs / PPID here (speed first).
                pbjs.setTargetingForGPTAsync(['Billboard']);
                googletag.pubads().refresh([Billboard]);
});
        });
    }

// Send requests to the SSPs and send bids to GAM for the ATF slots.
    function initNonBillboardAdserver(atfNonBillboardCodes) {
        if (pbjs.nonBillboardInitAdserverSet) return;
        pbjs.nonBillboardInitAdserverSet = true;
        googletag.cmd.push(function() {
            pbjs.que.push(function() {

                pbjs.getUserIdsAsync().then(function (userIds) {

                    var ppid;

                    try {
                        // pick up the PPID from local storage
                        ppid = JSON.parse(decodeURIComponent(window.localStorage.getItem('id5id'))).gp;

                        // pass the “gp” ID as PPID to GPT tag
                        if (ppid) {
                           googletag.pubads().setPublisherProvidedId(ppid); 
                        }

                       /* else {
                            console.log('ppid is not defined');
                        } */
                        
                    }

                    catch {
                        //console.log('gp is not defined');
                    }

                    pbjs.setTargetingForGPTAsync();
                    //pbjs.setPAAPIConfigForGPT();
                    var initialSlotsToRefresh = [Adhesion, P1, In_Text_1];

                    // Branding slots are desktop-only and may not be defined on smaller viewports.
                    if (typeof Branding_Left !== 'undefined' && Branding_Left) {
                        initialSlotsToRefresh.push(Branding_Left);
                    }

                    if (typeof Branding_Right !== 'undefined' && Branding_Right) {
                        initialSlotsToRefresh.push(Branding_Right);
                    }

                    googletag.pubads().refresh(initialSlotsToRefresh);

                });

            });
        });
    };
/*
    
    // ---------------------------------------------------------------------
    // BILLBOARD TIMED REFRESH (30s)
    //
    // Purpose:
    // - Ensure Billboard gets another auction after 30 seconds even if the
    //   user scrolls away (i.e. without requiring the viewability threshold).
    // - Uses the same safeguards as the viewability refresh:
    //     * respects GAM_NOREFRESH_* lists
    //     * respects MAX_REFRESH_COUNT_PER_SLOT via refresh_count targeting
    //     * avoids overlapping refreshes
    // ---------------------------------------------------------------------

    var billboardTimedRefreshTimerId = null;
    var billboardTimedRefreshInFlight = false;

    function scheduleBillboardTimedRefresh() {
        try {
            if (billboardTimedRefreshTimerId !== null) {
                return; // already scheduled
            }
            billboardTimedRefreshTimerId = setTimeout(function () {
                billboardTimedRefreshTimerId = null;
                attemptBillboardTimedRefresh();
            }, SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000);
        } catch (error) {
            // ignore
        }
    }

    function attemptBillboardTimedRefresh() {
        if (billboardTimedRefreshInFlight) {
            return;
        }

        // Respect "no refresh" list if someone adds Billboard back later.
        if (typeof GAM_NOREFRESH_ADUNITS !== "undefined" && GAM_NOREFRESH_ADUNITS.indexOf("Billboard") !== -1) {
            return;
        }

        billboardTimedRefreshInFlight = true;

        googletag.cmd.push(function () {
            var allSlots;
            try {
                allSlots = googletag.pubads().getSlots();
            } catch (e) {
                billboardTimedRefreshInFlight = false;
                scheduleBillboardTimedRefresh();
                return;
            }

            var gptSlot = resolveGptSlotByDivId(allSlots, "Billboard");
            if (!gptSlot) {
                billboardTimedRefreshInFlight = false;
                scheduleBillboardTimedRefresh();
                return;
            }

            // Read current refresh_count (defaults to 0).
            var refreshCount = 0;
            try {
                var refreshCountTargeting = gptSlot.getTargeting("refresh_count");
                refreshCount = parseInt((refreshCountTargeting && refreshCountTargeting[0]) || "0", 10);
                if (isNaN(refreshCount)) refreshCount = 0;
            } catch (e) {
                refreshCount = 0;
            }

            var maxRefresh = (typeof MAX_REFRESH_COUNT_PER_SLOT === "number" && MAX_REFRESH_COUNT_PER_SLOT >= 0)
                ? MAX_REFRESH_COUNT_PER_SLOT
                : 4;

            if (refreshCount >= maxRefresh) {
                billboardTimedRefreshInFlight = false;
                return;
            }

            // Skip refresh for excluded advertisers (if we can read it).
            var advertiserID;
            try {
                var responseInformation = gptSlot.getResponseInformation && gptSlot.getResponseInformation();
                advertiserID = responseInformation && responseInformation.advertiserId;
            } catch (e) {
                advertiserID = undefined;
            }

            if (typeof GAM_NOREFRESH_ADVERTISER_IDS !== "undefined" && GAM_NOREFRESH_ADVERTISER_IDS.indexOf(advertiserID) !== -1) {
                billboardTimedRefreshInFlight = false;
                scheduleBillboardTimedRefresh();
                return;
            }

            // Run a fresh HB auction for Billboard and refresh it.
            pbjs.que.push(function () {
                pbjs.requestBids({
                    timeout: getPrebidTimeoutForAdUnit("Billboard"),
                    adUnitCodes: ["Billboard"],
                    bidsBackHandler: function () {
                        pbjs.setTargetingForGPTAsync(["Billboard"]);

                        googletag.cmd.push(function () {
                            var nextRefreshCount = refreshCount + 1;
                            gptSlot.setTargeting("refresh_count", String(nextRefreshCount));
                            gptSlot.setTargeting("refresh_bucket", getRefreshBucket(nextRefreshCount));
                            googletag.pubads().refresh([gptSlot]);
                        });

                        billboardTimedRefreshInFlight = false;

                        // schedule the next timed refresh window (recurring) until max refreshes.
                        scheduleBillboardTimedRefresh();
                    }
                });
            });
        });
    }
*/
/*
// ---------------------------------------------------------------------
// BILLBOARD TIMED REFRESH (GATED BY VIEWABILITY)
//
// Purpose:
// - Give Billboard a second chance after ~30s, BUT only if it is currently
//   >= VISIBILITY_PERCENT_FOR_REFRESH viewable.
// - This keeps Billboard aligned with the "only refresh when viewable" rule,
//   while preserving the revenue uplift seen with timed refresh.
// ---------------------------------------------------------------------

var billboardTimedRefreshTimerId = null;
var billboardTimedRefreshInFlight = false;

function scheduleBillboardGatedTimedRefresh() {
    try {
        if (billboardTimedRefreshTimerId !== null) {
            return;
        }
        billboardTimedRefreshTimerId = setTimeout(function () {
            billboardTimedRefreshTimerId = null;
            attemptBillboardGatedTimedRefresh();
        }, SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000);
    } catch (error) {
        // ignore
    }
}

function attemptBillboardGatedTimedRefresh() {
    if (billboardTimedRefreshInFlight) {
        return;
    }

    billboardTimedRefreshInFlight = true;

    // Gate on viewability using the same refresh state as other slots.
    try {
        var billboardState = refreshStateByDivId && refreshStateByDivId.get ? refreshStateByDivId.get("Billboard") : null;
        var ratio = billboardState ? (billboardState.lastIntersectionRatio || 0) : 0;

        if (ratio < VISIBILITY_PERCENT_FOR_REFRESH) {
            billboardTimedRefreshInFlight = false;
            scheduleBillboardGatedTimedRefresh();
            return;
        }
    } catch (error) {
        billboardTimedRefreshInFlight = false;
        scheduleBillboardGatedTimedRefresh();
        return;
    }

    if (typeof GAM_NOREFRESH_ADUNITS !== "undefined" && GAM_NOREFRESH_ADUNITS.indexOf("Billboard") !== -1) {
        billboardTimedRefreshInFlight = false;
        return;
    }

    googletag.cmd.push(function () {
        var allSlots;
        try {
            allSlots = googletag.pubads().getSlots();
        } catch (e) {
            billboardTimedRefreshInFlight = false;
            scheduleBillboardGatedTimedRefresh();
            return;
        }

        var gptSlot = resolveGptSlotByDivId(allSlots, "Billboard");
        if (!gptSlot) {
            billboardTimedRefreshInFlight = false;
            scheduleBillboardGatedTimedRefresh();
            return;
        }

        var refreshCount = 0;
        try {
            var refreshCountTargeting = gptSlot.getTargeting("refresh_count");
            refreshCount = parseInt((refreshCountTargeting && refreshCountTargeting[0]) || "0", 10);
            if (isNaN(refreshCount)) refreshCount = 0;
        } catch (e) {
            refreshCount = 0;
        }

        if (typeof MAX_REFRESH_COUNT_PER_SLOT === "number" && MAX_REFRESH_COUNT_PER_SLOT >= 0 && refreshCount >= MAX_REFRESH_COUNT_PER_SLOT) {
            billboardTimedRefreshInFlight = false;
            return;
        }

        var advertiserID;
        try {
            var responseInformation = gptSlot.getResponseInformation && gptSlot.getResponseInformation();
            advertiserID = responseInformation && responseInformation.advertiserId;
        } catch (e) {
            advertiserID = undefined;
        }

        if (typeof GAM_NOREFRESH_ADVERTISER_IDS !== "undefined" && GAM_NOREFRESH_ADVERTISER_IDS.indexOf(advertiserID) !== -1) {
            billboardTimedRefreshInFlight = false;
            scheduleBillboardGatedTimedRefresh();
            return;
        }

        pbjs.que.push(function () {
            pbjs.requestBids({
                timeout: getPrebidTimeoutForAdUnit("Billboard"),
                adUnitCodes: ["Billboard"],
                bidsBackHandler: function () {
                    pbjs.setTargetingForGPTAsync(["Billboard"]);

                    googletag.cmd.push(function () {
                        var nextRefreshCount = refreshCount + 1;
                        gptSlot.setTargeting("refresh_count", String(nextRefreshCount));
                            gptSlot.setTargeting("refresh_bucket", getRefreshBucket(nextRefreshCount));
                        googletag.pubads().refresh([gptSlot]);
                    });

                    billboardTimedRefreshInFlight = false;
                    scheduleBillboardGatedTimedRefresh();
                }
            });
        });
    });
}
*/



//Add BTF ad units.
    pbjs.que.push(function() {
        pbjs.addAdUnits(adUnitsBTF);
    });

    // Use IntersectionObserver API to check whether an ad slot is at the certain distance. 
    var observer = new IntersectionObserver (function(entries) {

        entries.forEach(entry => {

            if (entry.isIntersecting) {

                let adSlot = entry.target.id; // Get the div id of the slot being observed. 

                // Request bids and push the ads to GAM. 
                pbjs.que.push(function() {
                    pbjs.requestBids({
                        timeout: PREBID_TIMEOUT,
                        adUnitCodes: [adSlot],
                        bidsBackHandler: function() {
                            pbjs.setTargetingForGPTAsync([adSlot]);
    
                            // If div with the certain ID is present and observed, refresh GAM slot.
                            if (adSlot === 'Billboard_2') {
                                googletag.pubads().refresh([Billboard_2]); 
                            } 

                            else if (adSlot === 'Billboard_3') {
                                googletag.pubads().refresh([Billboard_3]); 
                            } 

                            else if (adSlot === 'Billboard_4') {
                                googletag.pubads().refresh([Billboard_4]); 
                            } 

                            else if (adSlot === 'Billboard_5') {
                                googletag.pubads().refresh([Billboard_5]); 
                            } 

                            else if (adSlot === 'P2') {
                                googletag.pubads().refresh([P2]); 
                            } 
        
                            else if (adSlot === 'P3') {
                                googletag.pubads().refresh([P3]); 
                            } 
                            
                            else if (adSlot === 'P4') {
                                googletag.pubads().refresh([P4]); 
                            } 

                            else if (adSlot === 'P5') {
                                googletag.pubads().refresh([P5]); 
                            } 

                            else if (adSlot === 'P6') {
                                googletag.pubads().refresh([P6]); 
                            } 

                            else if (adSlot === 'In_Text_2') {
                                googletag.pubads().refresh([In_Text_2]); 
                            } 

                            else if (adSlot === 'In_Text_3') {
                                googletag.pubads().refresh([In_Text_3]); 
                            } 

                            else if (adSlot === 'In_Text_4') {
                                googletag.pubads().refresh([In_Text_4]); 
                            } 

                            else if (adSlot === 'In_Text_5') {
                                googletag.pubads().refresh([In_Text_5]); 
                            } 

                            else if (adSlot === 'In_Text_6') {
                                googletag.pubads().refresh([In_Text_6]); 
                            } 

                            else if (adSlot === 'In_Text_7') {
                                googletag.pubads().refresh([In_Text_7]); 
                            } 

                            else if (adSlot === 'In_Text_8') {
                                googletag.pubads().refresh([In_Text_8]); 
                            } 

                            else if (adSlot === 'In_Text_9') {
                                googletag.pubads().refresh([In_Text_9]); 
                            } 

                            else if (adSlot === 'In_Text_10') {
                                googletag.pubads().refresh([In_Text_10]); 
                            } 

                        }
                    });
                });
                
                // -------------------------------------------------------------
                // Register this lazily-loaded slot for viewability-based refresh.
                //
                // The refresh observer is initialized once from currently-defined
                // GPT slots. Below-the-fold slots (like P5) are defined later, so
                // we must begin observing them here, right after they are loaded.
                // -------------------------------------------------------------
                try {
                    if (typeof viewabilityObserver !== "undefined" && viewabilityObserver && entry.target) {
                        getOrCreateRefreshState(adSlot);
                        viewabilityObserver.observe(entry.target);
                        adsDebugLog("[ads-refresh]", adSlot, "refresh_observer_attached_from_lazy_load");
                    }
                } catch (error) {
                    adsDebugLog("[ads-refresh]", adSlot, "refresh_observer_attach_failed", { error: String(error) });
                }

observer.unobserve(entry.target); // Stop observing the ad slot which has alredy been seen. 
            }
        })
    }, {rootMargin: DISTANCE_IN_PIXELS_FOR_LAZY_LOADING}); // Distance to the ad slot.

    document.querySelectorAll('.lazyAd').forEach(slots => { observer.observe(slots) }); // Check all divs with the class lazyAd and observe them all. 

    
    
    // ---------------------------------------------------------------------
    
    // ---------------------------------------------------------------------
    // VIEWABILITY-BASED REFRESH (HIGH PRIORITY FIXES)
    //
    // Goals:
    //  1) Use intersectionRatio (not isIntersecting) to represent "X% viewable" correctly.
    //  2) Require the slot to stay >= VISIBILITY_PERCENT_FOR_REFRESH for the
    //     advertiser-specific refresh interval before refreshing.
    //  3) Pause + reset the continuous timer when the tab is hidden.
    //  4) Enforce a hard MIN_REFRESH_INTERVAL_MS per slot (defensive throttle).
    //  5) Cap refresh_count at MAX_REFRESH_COUNT_PER_SLOT for A/B testing.
    //
    // Nothing else about auctions, bidders, or lazy loading is changed.
    // ---------------------------------------------------------------------

    // Max refreshes for all slots. null preserves the current unlimited behavior.
    var MAX_REFRESH_COUNT_PER_SLOT = null;

    // Hard per-slot minimum interval (ms). We set it equal to the continuous viewability
    // wait time to preserve the existing cadence while protecting against double triggers.
    var MIN_REFRESH_INTERVAL_MS = SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000; // legacy debug baseline; runtime uses getRefreshIntervalSeconds()

    // Per-slot refresh state keyed by div id.
    var refreshStateByDivId = new Map();

    function getOrCreateRefreshState(divId) {
        if (refreshStateByDivId.has(divId)) {
            return refreshStateByDivId.get(divId);
        }

        var initialState = {
            divId: divId,
            isAboveVisibilityThreshold: false,
            lastIntersectionRatio: 0,
            continuousViewabilityStartTimestamp: null,
            lastRefreshTimestamp: 0,
            scheduledRefreshTimeoutId: null,
            // Cumulative timer state (used only when USE_CUMULATIVE_VIEWABILITY_TIMER is true)
            cumulativeViewableMs: 0,
            lastAboveThresholdTimestamp: null,
            currentRefreshCount: 0,
            lastAuctionQuality: null,
            lastRenderResult: null,
            auctionQualityHistory: []
        };

        refreshStateByDivId.set(divId, initialState);
        return initialState;
    }

    function clearScheduledRefresh(divId) {
        var state = refreshStateByDivId.get(divId);
        if (!state) {
            return;
        }
        if (state.scheduledRefreshTimeoutId !== null) {
            clearTimeout(state.scheduledRefreshTimeoutId);
            state.scheduledRefreshTimeoutId = null;
        }
    }

    function scheduleRefreshWindowFromNow(divId) {
    var state = refreshStateByDivId.get(divId);
    if (!state) {
        return;
    }

    if (document.visibilityState !== "visible") {
        adsDebugLog("[ads-refresh]", divId, "skip schedule: tab_hidden");
        return;
    }

    if (!state.isAboveVisibilityThreshold) {
        adsDebugLog(
            "[ads-refresh]",
            divId,
            "skip schedule: below_threshold",
            { ratio: state.lastIntersectionRatio }
        );
        return;
    }

    clearScheduledRefresh(divId);

    var refreshIntervalSeconds = getRefreshIntervalSeconds(divId);
    var refreshIntervalMs = refreshIntervalSeconds * 1000;

    // Default (continuous) behavior: require the selected interval of uninterrupted viewability.
    if (!USE_CUMULATIVE_VIEWABILITY_TIMER) {
        state.continuousViewabilityStartTimestamp = Date.now();

        adsDebugLog(
            "[ads-refresh]",
            divId,
            "schedule refresh window (continuous)",
            { seconds: refreshIntervalSeconds, ratio: state.lastIntersectionRatio }
        );

        state.scheduledRefreshTimeoutId = setTimeout(function () {
            attemptRefresh(divId);
        }, refreshIntervalMs);

        return;
    }

    // Cumulative behavior: count viewability time across multiple segments, but require:
    // - current ratio >= VISIBILITY_PERCENT_FOR_REFRESH
    // - last continuous stretch >= MIN_CONTINUOUS_VIEWABILITY_SEGMENT_MS
    if (state.lastAboveThresholdTimestamp === null) {
        state.lastAboveThresholdTimestamp = Date.now();
    }

    var remainingMs = refreshIntervalMs - (state.cumulativeViewableMs || 0);
    if (remainingMs < 0) {
        remainingMs = 0;
    }

    // Enforce at least MIN_CONTINUOUS_VIEWABILITY_SEGMENT_MS in the current stretch.
    var waitMs = Math.max(remainingMs, MIN_CONTINUOUS_VIEWABILITY_SEGMENT_MS);

    adsDebugLog(
        "[ads-refresh]",
        divId,
        "schedule refresh window (cumulative)",
        {
            remainingMs: remainingMs,
            waitMs: waitMs,
            cumulativeMs: state.cumulativeViewableMs || 0,
            intervalSeconds: refreshIntervalSeconds,
            ratio: state.lastIntersectionRatio
        }
    );

    state.scheduledRefreshTimeoutId = setTimeout(function () {
        attemptRefresh(divId);
    }, waitMs);
}


    function pauseAllViewabilityTimersAndCancelSchedules() {
        var pauseTimestamp = Date.now();

        refreshStateByDivId.forEach(function (state) {
            if (
                USE_CUMULATIVE_VIEWABILITY_TIMER &&
                state.lastAboveThresholdTimestamp !== null
            ) {
                state.cumulativeViewableMs = (state.cumulativeViewableMs || 0) +
                    Math.max(0, pauseTimestamp - state.lastAboveThresholdTimestamp);
                state.lastAboveThresholdTimestamp = null;
            }

            state.continuousViewabilityStartTimestamp = null;
            clearScheduledRefresh(state.divId);
        });
    }

    // Expose a read-only snapshot for debugging (only when debug is enabled).
    // Access in console: window.__adsDebugState()
    if (ADS_DEBUG_ENABLED) {
        window.__adsDebugState = function () {
            try {
                var states = [];
                refreshStateByDivId.forEach(function (value, key) {
                    states.push({
                        divId: key,
                        isAboveVisibilityThreshold: Boolean(value.isAboveVisibilityThreshold),
                        lastIntersectionRatio: Number(value.lastIntersectionRatio || 0),
                        continuousViewabilityStartTimestamp: value.continuousViewabilityStartTimestamp,
                        cumulativeViewableMs: (typeof value.cumulativeViewableMs === "number") ? value.cumulativeViewableMs : null,
                        lastAboveThresholdTimestamp: value.lastAboveThresholdTimestamp || null,
                        lastRefreshTimestamp: value.lastRefreshTimestamp,
                        hasScheduledTimeout: value.scheduledRefreshTimeoutId !== null,
                        currentRefreshCount: Number(value.currentRefreshCount || 0),
                        refreshIntervalSeconds: getRefreshIntervalSeconds(key),
                        lastAuctionQuality: value.lastAuctionQuality || null,
                        lastRenderResult: value.lastRenderResult || null
                    });
                });
                return {
                    visibilityThreshold: VISIBILITY_PERCENT_FOR_REFRESH,
                    defaultRefreshIntervalSeconds: DEFAULT_REFRESH_INTERVAL_SECONDS,
                    directAdvertiserRefreshIntervalSeconds: DIRECT_ADVERTISER_REFRESH_INTERVAL_SECONDS,
                    maxRefreshCountPerSlot: MAX_REFRESH_COUNT_PER_SLOT,
                    states: states
                };
            } catch (error) {
                return { error: String(error) };
            }
        };
    }

    // Pause viewability timers when the tab is hidden.
    // When the tab becomes visible again, restart the window ONLY for slots that are
    // currently above the visibility threshold.
    document.addEventListener("visibilitychange", function () {
        if (document.visibilityState !== "visible") {
            adsDebugLog("[ads-refresh]", "tab_hidden -> pause viewability timers");
            pauseAllViewabilityTimersAndCancelSchedules();
            return;
        }

        adsDebugLog("[ads-refresh]", "tab_visible -> restart eligible timers");
        refreshStateByDivId.forEach(function (state) {
            if (state.isAboveVisibilityThreshold) {
                scheduleRefreshWindowFromNow(state.divId);
            }
        });
    });


    function getRefreshBucket(refreshCount) {
        refreshCount = parseInt(refreshCount, 10);
        if (isNaN(refreshCount) || refreshCount <= 0) {
            return "initial";
        }
        if (refreshCount <= 3) {
            return "r1_3";
        }
        return "r4_plus";
    }


    function isDirectAdvertiserId(advertiserId) {
        if (
            advertiserId === null ||
            advertiserId === undefined ||
            advertiserId === ""
        ) {
            return false;
        }

        return GAM_DIRECT_ADVERTISER_IDS.some(function (configuredId) {
            return String(configuredId) === String(advertiserId);
        });
    }

    function getCurrentRenderedAdvertiserId(divId) {
        var state = refreshStateByDivId.get(divId);
        var renderResult = state && state.lastRenderResult;
        return renderResult ? renderResult.advertiserId : null;
    }

    function getRefreshIntervalSeconds(divId) {
        var useDirectAdvertiserInterval =
            isDirectAdvertiserId(getCurrentRenderedAdvertiserId(divId));

        if (useDirectAdvertiserInterval) {
            return DIRECT_ADVERTISER_REFRESH_INTERVAL_SECONDS;
        }

        return DEFAULT_REFRESH_INTERVAL_SECONDS;
    }


// -----------------------------------------------------------------------------
// PASSIVE AUCTION-QUALITY TELEMETRY (NO DELIVERY DECISIONS)
// -----------------------------------------------------------------------------
// This instrumentation records Prebid auction competition and the previous GPT
// render result. It does not delay, cancel, prioritize, or otherwise alter ads.
// A small per-slot history is retained in memory for inspection during a page view.
// The aq_* slot targeting values can also be registered as dynamic GAM keys later.
var AUCTION_QUALITY_HISTORY_LIMIT = 50;

// Tracks recent Prebid wins only for passive source classification.
// This has no effect on auctions, targeting decisions, or refresh cadence.
var auctionQualityRecentPrebidWinsByAdUnit = {};

pbjs.que.push(function () {
    if (window.__zenaAuctionQualityBidWonListenerInstalled) return;
    window.__zenaAuctionQualityBidWonListenerInstalled = true;

    if (typeof pbjs.onEvent === "function") {
        pbjs.onEvent("bidWon", function (bid) {
            try {
                var adUnitCode = bid && bid.adUnitCode;
                if (!adUnitCode) return;
                auctionQualityRecentPrebidWinsByAdUnit[adUnitCode] = {
                    timestamp: Date.now(),
                    bidder: bid.bidder || bid.bidderCode || null,
                    cpm: Number(bid.cpm || 0),
                    adId: bid.adId || null,
                    auctionId: bid.auctionId || null
                };
            } catch (error) {
                adsDebugLog("[auction-quality] bidWon_capture_failed", String(error));
            }
        });
    }
});

function getAuctionQualityCountBucket(count) {
    count = Number(count) || 0;
    if (count <= 0) return "0";
    if (count === 1) return "1";
    if (count === 2) return "2";
    if (count === 3) return "3";
    if (count === 4) return "4";
    return "5plus";
}

function getAuctionQualityTopBidBucket(cpm) {
    cpm = Number(cpm) || 0;
    if (cpm <= 0) return "no_bid";
    if (cpm < 0.10) return "lt_010";
    if (cpm < 0.20) return "010_019";
    if (cpm < 0.50) return "020_049";
    if (cpm < 1.00) return "050_099";
    return "100_plus";
}

function getAuctionQualityPreviousFill(previousRenderResult) {
    if (!previousRenderResult) return "unknown";
    return previousRenderResult.isEmpty ? "unfilled" : "filled";
}

function getAuctionQualityPreviousSource(previousRenderResult) {
    if (!previousRenderResult) return "unknown";
    if (previousRenderResult.isEmpty) return "unfilled";
    if (previousRenderResult.source === "prebid") return "prebid";
    return "gam";
}

function collectAuctionQuality(divId, bidResponses, timedOut, auctionId) {
    var state = getOrCreateRefreshState(divId);
    var bids = [];

    try {
        var slotResponse = bidResponses && bidResponses[divId];
        if (slotResponse && Array.isArray(slotResponse.bids)) {
            bids = slotResponse.bids.filter(function (bid) {
                return bid && Number(bid.cpm) >= 0;
            });
        }
    } catch (error) {
        bids = [];
    }

    var topBid = null;
    bids.forEach(function (bid) {
        if (!topBid || Number(bid.cpm || 0) > Number(topBid.cpm || 0)) {
            topBid = bid;
        }
    });

    var bidderNames = [];
    bids.forEach(function (bid) {
        var bidderName = bid.bidder || bid.bidderCode;
        if (bidderName && bidderNames.indexOf(bidderName) === -1) {
            bidderNames.push(bidderName);
        }
    });

    var now = Date.now();
    var quality = {
        timestamp: now,
        auctionId: auctionId || null,
        divId: divId,
        refreshCountBeforeRequest: Number(state.currentRefreshCount || 0),
        refreshBucketBeforeRequest: getRefreshBucket(Number(state.currentRefreshCount || 0)),
        timeSinceLastRefreshMs: state.lastRefreshTimestamp ? (now - state.lastRefreshTimestamp) : null,
        validBidCount: bids.length,
        bidderCount: bidderNames.length,
        bidderNames: bidderNames,
        highestBidCpm: topBid ? Number(topBid.cpm || 0) : 0,
        highestBidder: topBid ? (topBid.bidder || topBid.bidderCode || null) : null,
        timedOut: Boolean(timedOut),
        previousRenderResult: state.lastRenderResult || null
    };

    state.lastAuctionQuality = quality;
    state.auctionQualityHistory.push(quality);
    if (state.auctionQualityHistory.length > AUCTION_QUALITY_HISTORY_LIMIT) {
        state.auctionQualityHistory.shift();
    }

    return quality;
}

function applyAuctionQualityTargeting(gptSlot, quality) {
    if (!gptSlot || !quality) return;
    try {
        gptSlot.setTargeting("aq_bid_count", getAuctionQualityCountBucket(quality.validBidCount));
        gptSlot.setTargeting("aq_bidder_count", getAuctionQualityCountBucket(quality.bidderCount));
        gptSlot.setTargeting("aq_top_bid_bucket", getAuctionQualityTopBidBucket(quality.highestBidCpm));
        gptSlot.setTargeting("aq_timed_out", quality.timedOut ? "yes" : "no");
        gptSlot.setTargeting("aq_prev_fill", getAuctionQualityPreviousFill(quality.previousRenderResult));
        gptSlot.setTargeting("aq_prev_source", getAuctionQualityPreviousSource(quality.previousRenderResult));
    } catch (error) {
        adsDebugLog("[auction-quality] targeting_failed", quality.divId, String(error));
    }
}

window.__zenaAuctionQualitySnapshot = function () {
    var snapshot = {};
    refreshStateByDivId.forEach(function (state, divId) {
        snapshot[divId] = {
            currentRefreshCount: Number(state.currentRefreshCount || 0),
            lastAuctionQuality: state.lastAuctionQuality || null,
            lastRenderResult: state.lastRenderResult || null,
            history: (state.auctionQualityHistory || []).slice()
        };
    });
    try {
        return JSON.parse(JSON.stringify(snapshot));
    } catch (error) {
        return snapshot;
    }
};


    function resolveGptSlotByDivId(allSlots, divId) {
        for (var slotIndex = 0; slotIndex < allSlots.length; slotIndex++) {
            var candidateSlot = allSlots[slotIndex];
            if (
                candidateSlot &&
                candidateSlot.getSlotElementId &&
                candidateSlot.getSlotElementId() === divId
            ) {
                return candidateSlot;
            }
        }
        return null;
    }

    function attemptRefresh(divId) {
        var state = refreshStateByDivId.get(divId);
        if (!state) {
            return;
        }

        // Clear the scheduled id first; we reschedule explicitly below if still eligible.
        state.scheduledRefreshTimeoutId = null;

        // Hard gates.
        if (document.visibilityState !== "visible") {
            adsDebugLog("[ads-refresh]", divId, "skip refresh: tab_hidden");
            state.continuousViewabilityStartTimestamp = null;
            return;
        }

        if (!state.isAboveVisibilityThreshold) {
            adsDebugLog("[ads-refresh]", divId, "skip refresh: below_threshold", { ratio: state.lastIntersectionRatio });
            state.continuousViewabilityStartTimestamp = null;
            return;
        }

        // Defensive throttle: use the same per-slot/per-bucket interval as scheduling.
        var minimumRefreshIntervalMs = getRefreshIntervalSeconds(divId) * 1000;
        if (state.lastRefreshTimestamp && (Date.now() - state.lastRefreshTimestamp) < minimumRefreshIntervalMs) {
            adsDebugLog(
                "[ads-refresh]",
                divId,
                "skip refresh: min_interval",
                { sinceMs: (Date.now() - state.lastRefreshTimestamp), minimumMs: minimumRefreshIntervalMs }
            );
            scheduleRefreshWindowFromNow(divId);
            return;
        }

        // Resolve and refresh inside googletag.cmd to guarantee GPT readiness.
        googletag.cmd.push(function () {
            var allSlots;
            try {
                allSlots = googletag.pubads().getSlots();
            } catch (error) {
                adsDebugLog("[ads-refresh]", divId, "skip refresh: gpt_not_ready");
                scheduleRefreshWindowFromNow(divId);
                return;
            }

            var gptSlot = resolveGptSlotByDivId(allSlots, divId);
            if (!gptSlot) {
                adsDebugLog("[ads-refresh]", divId, "skip refresh: slot_not_found");
                scheduleRefreshWindowFromNow(divId);
                return;
            }

            // Determine current refresh count from slot targeting.
            var refreshCount = 0;
            try {
                var refreshCountTargeting = gptSlot.getTargeting("refresh_count");
                refreshCount = parseInt((refreshCountTargeting && refreshCountTargeting[0]) || "0", 10);
                if (isNaN(refreshCount)) {
                    refreshCount = 0;
                }
            } catch (error) {
                refreshCount = 0;
            }
            state.currentRefreshCount = refreshCount;

            if (typeof MAX_REFRESH_COUNT_PER_SLOT === "number" && MAX_REFRESH_COUNT_PER_SLOT >= 0 && refreshCount >= MAX_REFRESH_COUNT_PER_SLOT) {
                adsDebugLog("[ads-refresh]", divId, "skip refresh: max_refreshes_reached", { refreshCount: refreshCount });
                return;
            }

            // Block refresh for excluded advertisers and excluded ad units (existing behavior).
            var advertiserID;
            try {
                var responseInformation = gptSlot.getResponseInformation && gptSlot.getResponseInformation();
                advertiserID = responseInformation && responseInformation.advertiserId;
            } catch (error) {
                advertiserID = undefined;
            }

            if (GAM_NOREFRESH_ADVERTISER_IDS.includes(advertiserID)) {
                adsDebugLog("[ads-refresh]", divId, "skip refresh: no_refresh_advertiser", { advertiserID: advertiserID });
                scheduleRefreshWindowFromNow(divId);
                return;
            }

            if (GAM_NOREFRESH_ADUNITS.includes(divId)) {
                adsDebugLog("[ads-refresh]", divId, "skip refresh: no_refresh_adunit");
                scheduleRefreshWindowFromNow(divId);
                return;
            }

            // Keep adUnitCodes semantics: this wrapper uses divId as the Prebid ad unit code.
            var adUnitCode = divId;

            pbjs.que.push(function () {
                pbjs.requestBids({
                    timeout: PREBID_TIMEOUT,
                    adUnitCodes: [adUnitCode],
                    bidsBackHandler: function (bidResponses, timedOut, auctionId) {
                        var auctionQuality = collectAuctionQuality(divId, bidResponses, timedOut, auctionId);
                        pbjs.setTargetingForGPTAsync([adUnitCode]);

                        googletag.cmd.push(function () {
                            // Update refresh_count before calling refresh so targeting is present.
                            var nextRefreshCount = refreshCount + 1;
                            state.currentRefreshCount = nextRefreshCount;
                            gptSlot.setTargeting("refresh_count", String(nextRefreshCount));
                            gptSlot.setTargeting("refresh_bucket", getRefreshBucket(nextRefreshCount));
                            applyAuctionQualityTargeting(gptSlot, auctionQuality);

                            adsDebugLog(
                                "[ads-refresh]",
                                divId,
                                "REFRESH",
                                { refreshCount: nextRefreshCount, ratio: state.lastIntersectionRatio }
                            );

                            googletag.pubads().refresh([gptSlot]);
                        });

                        state.lastRefreshTimestamp = Date.now();

                        if (USE_CUMULATIVE_VIEWABILITY_TIMER) {
                        state.cumulativeViewableMs = 0;
                        state.lastAboveThresholdTimestamp = Date.now();
                    }

                    // If the slot is still eligible, schedule the next refresh window from now.
                        scheduleRefreshWindowFromNow(divId);
                    }
                });
            });
        });
    }

    // Track actual viewability percentage.
    // IMPORTANT: isIntersecting only means "some pixels visible". We must use intersectionRatio.
    var viewabilityObserver = new IntersectionObserver(function (viewabilityEntries) {
        viewabilityEntries.forEach(function (viewabilityEntry) {
            var divId = viewabilityEntry.target.id;
            if (!divId) {
                return;
            }

            var state = getOrCreateRefreshState(divId);

            var ratio = viewabilityEntry.intersectionRatio || 0;
            state.lastIntersectionRatio = ratio;

            var isAbove = ratio >= VISIBILITY_PERCENT_FOR_REFRESH;
            var wasAbove = state.isAboveVisibilityThreshold;

            state.isAboveVisibilityThreshold = isAbove;

            // If we cross above threshold, start the refresh window.
            if (isAbove && !wasAbove) {
                if (USE_CUMULATIVE_VIEWABILITY_TIMER) {
                    state.lastAboveThresholdTimestamp = Date.now();
                }
                adsDebugLog("[ads-refresh]", divId, "threshold_enter", { ratio: ratio });
                scheduleRefreshWindowFromNow(divId);
                return;
            }

            // If we drop below threshold, reset timing and cancel any pending refresh.
            if (!isAbove && wasAbove) {
                adsDebugLog("[ads-refresh]", divId, "threshold_exit", { ratio: ratio });
                if (USE_CUMULATIVE_VIEWABILITY_TIMER) {
                    if (state.lastAboveThresholdTimestamp !== null) {
                        state.cumulativeViewableMs = (state.cumulativeViewableMs || 0) + (Date.now() - state.lastAboveThresholdTimestamp);
                        state.lastAboveThresholdTimestamp = null;
                    }
                }
                state.continuousViewabilityStartTimestamp = null;
                clearScheduledRefresh(divId);
                return;
            }

            // If we are above threshold and nothing is scheduled (e.g. after tab resume),
            // ensure we have an active window running.
            if (isAbove && state.scheduledRefreshTimeoutId === null && document.visibilityState === "visible") {
                if (state.continuousViewabilityStartTimestamp === null) {
                    scheduleRefreshWindowFromNow(divId);
                }
            }
        });
    }, { threshold: [0, VISIBILITY_PERCENT_FOR_REFRESH, 1] });

    // Observe all currently-defined GPT slots.
    googletag.pubads().getSlots().forEach(function (slotAd) {
        var divId = slotAd.getSlotElementId();
        if (!divId) {
            return;
        }

        // Initialize state eagerly for debugging and for visibilitychange rescheduling.
        getOrCreateRefreshState(divId);

        var viewabilitySlotElements = document.querySelectorAll("#" + divId);
        viewabilitySlotElements.forEach(function (viewabilitySlotElement) {
            viewabilityObserver.observe(viewabilitySlotElement);
        });
    });



}

// -----------------------------------------------------------------------------
// Early wrapper start test
// -----------------------------------------------------------------------------
// Start the ad wrapper as early as possible once the DOM is usable.
// Important: this block is intentionally placed at the END of the file, after
// googletag/pbjs globals, config variables, and runWrapper() are defined.
function startAdsWrapper(reason) {
    if (window.prebidAuctionRun) {
        return;
    }

    window.prebidAuctionRun = true;

    try {
        clearTimeout(window.adsLoadTimer);
    } catch (error) {
        // Intentionally ignore cleanup failures.
    }

    try {
        adsDebugLog('Ad Wrapper: Running early because:', reason);
    } catch (error) {
        // Intentionally ignore logging failures.
    }

    // Queue the wrapper until GPT is fully loaded.
    // Starting the wrapper earlier is useful, but runWrapper() also reads
    // googletag.pubads(), so it must not execute before gpt.js has initialized.
    try {
        googletag.cmd.push(function () {
            runWrapper();
        });
    } catch (error) {
        // Last-resort fallback: keep behavior fail-safe instead of throwing.
        window.adsLoadTimer = setTimeout(function () {
            try {
                googletag.cmd.push(function () {
                    runWrapper();
                });
            } catch (innerError) {}
        }, 300);
    }
}

if (document.readyState === 'interactive' || document.readyState === 'complete') {
    startAdsWrapper('document-ready-state');
} else {
    document.addEventListener('DOMContentLoaded', function () {
        startAdsWrapper('domcontentloaded');
    });
}

// Safety fallback only.
window.adsLoadTimer = setTimeout(function () {
    startAdsWrapper('fallback-timeout');
}, 1200);
